/* tslint:disable */
/* eslint-disable */
/**
 * IAM API
 * IAM API docs <br><br> <a href=\"/schemas/v1/openapi.json\">OpenAPI Document (json)</a>
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * The access level of the case
 * @export
 * @enum {string}
 */

export const AccessLevel = {
    ReadOnly: 'read-only'
} as const;

export type AccessLevel = typeof AccessLevel[keyof typeof AccessLevel];


/**
 * 
 * @export
 * @interface BadRequestDto
 */
export interface BadRequestDto {
    /**
     * 
     * @type {number}
     * @memberof BadRequestDto
     */
    'statusCode': BadRequestDtoStatusCodeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof BadRequestDto
     */
    'message': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BadRequestDto
     */
    'error': BadRequestDtoErrorEnum;
}

export const BadRequestDtoStatusCodeEnum = {
    NUMBER_400: 400
} as const;

export type BadRequestDtoStatusCodeEnum = typeof BadRequestDtoStatusCodeEnum[keyof typeof BadRequestDtoStatusCodeEnum];
export const BadRequestDtoErrorEnum = {
    BadRequest: 'Bad Request'
} as const;

export type BadRequestDtoErrorEnum = typeof BadRequestDtoErrorEnum[keyof typeof BadRequestDtoErrorEnum];

/**
 * 
 * @export
 * @interface ConflictDto
 */
export interface ConflictDto {
    /**
     * 
     * @type {number}
     * @memberof ConflictDto
     */
    'statusCode': ConflictDtoStatusCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof ConflictDto
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof ConflictDto
     */
    'error': ConflictDtoErrorEnum;
}

export const ConflictDtoStatusCodeEnum = {
    NUMBER_409: 409
} as const;

export type ConflictDtoStatusCodeEnum = typeof ConflictDtoStatusCodeEnum[keyof typeof ConflictDtoStatusCodeEnum];
export const ConflictDtoErrorEnum = {
    Conflict: 'Conflict'
} as const;

export type ConflictDtoErrorEnum = typeof ConflictDtoErrorEnum[keyof typeof ConflictDtoErrorEnum];

/**
 * 
 * @export
 * @interface CreateCustomRoleDto
 */
export interface CreateCustomRoleDto {
    /**
     * 
     * @type {string}
     * @memberof CreateCustomRoleDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomRoleDto
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCustomRoleDto
     */
    'fixedBindings'?: Array<string>;
    /**
     * Only 100 permissions per role is allowed. The only exception is pos permissions, we allow up to 500 of them 
     * @type {Array<CustomRolePermissionDtoWithoutAliasDto>}
     * @memberof CreateCustomRoleDto
     */
    'permissions': Array<CustomRolePermissionDtoWithoutAliasDto>;
}
/**
 * 
 * @export
 * @interface CreateExternalAppDto
 */
export interface CreateExternalAppDto {
    /**
     * Application name
     * @type {string}
     * @memberof CreateExternalAppDto
     */
    'name': string;
    /**
     * Describes your app\'s most notable characteristics
     * @type {string}
     * @memberof CreateExternalAppDto
     */
    'description'?: string;
    /**
     * Key that will give you a possibility to exchange federated token on IAM token
     * @type {string}
     * @memberof CreateExternalAppDto
     */
    'apiKey'?: string;
}
/**
 * 
 * @export
 * @interface CreateGroupDto
 */
export interface CreateGroupDto {
    /**
     * 
     * @type {string}
     * @memberof CreateGroupDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateGroupDto
     */
    'description'?: string;
    /**
     * An optional id of a group. Will be auto-generated if not passed
     * @type {string}
     * @memberof CreateGroupDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface CreateGroupLinkDto
 */
export interface CreateGroupLinkDto {
    /**
     * 
     * @type {string}
     * @memberof CreateGroupLinkDto
     */
    'documentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGroupLinkDto
     */
    'userGroupDocumentId': string;
}
/**
 * 
 * @export
 * @interface CreateOidcIdentityProviderDto
 */
export interface CreateOidcIdentityProviderDto {
    /**
     * 
     * @type {ExternalIdField}
     * @memberof CreateOidcIdentityProviderDto
     */
    'externalIdField': ExternalIdField;
    /**
     * 
     * @type {string}
     * @memberof CreateOidcIdentityProviderDto
     */
    'name': string;
    /**
     * 
     * @type {IdentityProviderType}
     * @memberof CreateOidcIdentityProviderDto
     */
    'type': IdentityProviderType;
    /**
     * 
     * @type {IdpUserType}
     * @memberof CreateOidcIdentityProviderDto
     */
    'userType': IdpUserType;
    /**
     * 
     * @type {CreateOidcIdentityProviderDtoExternalIdpLogoutConfig}
     * @memberof CreateOidcIdentityProviderDto
     */
    'externalIdpLogoutConfig'?: CreateOidcIdentityProviderDtoExternalIdpLogoutConfig;
    /**
     * 
     * @type {string}
     * @memberof CreateOidcIdentityProviderDto
     */
    'clientId': string;
    /**
     * Must be a valid url
     * @type {string}
     * @memberof CreateOidcIdentityProviderDto
     */
    'issuer': string;
    /**
     * 
     * @type {OidcAuthFlow}
     * @memberof CreateOidcIdentityProviderDto
     */
    'flow'?: OidcAuthFlow;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOidcIdentityProviderDto
     */
    'usePKCE'?: boolean;
    /**
     * Space delimited, case sensitive list of ASCII string values that specifies whether the Authorization Server prompts the End-User for reauthentication and consent. The defined values are: none | login | consent | select_account For more info see: https://openid.net/specs/openid-connect-core-1_0.html#AuthRequest
     * @type {string}
     * @memberof CreateOidcIdentityProviderDto
     */
    'prompt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOidcIdentityProviderDto
     */
    'clientSecret'?: string;
}


/**
 * External IdP logout configuration. Used by the UI to specify how to logout from the external IdP.
 * @export
 * @interface CreateOidcIdentityProviderDtoExternalIdpLogoutConfig
 */
export interface CreateOidcIdentityProviderDtoExternalIdpLogoutConfig {
    /**
     * If enabled, UI will redirect to externalIdpLogout.redirectUrl on logout
     * @type {boolean}
     * @memberof CreateOidcIdentityProviderDtoExternalIdpLogoutConfig
     */
    'enabled': boolean;
    /**
     * Must be a valid url
     * @type {string}
     * @memberof CreateOidcIdentityProviderDtoExternalIdpLogoutConfig
     */
    'redirectUrl': string;
}
/**
 * 
 * @export
 * @interface CreatePermissionDto
 */
export interface CreatePermissionDto {
    /**
     * Permission id must follow the pattern: {systemPrefix}.{resource}.{action} and contain a-z letters and hyphens where the systemPrefix size is 3, the resource and action parts are between 2 and 16 characters.
     * @type {string}
     * @memberof CreatePermissionDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePermissionDto
     */
    'description'?: string;
    /**
     * optional alias for the permission, up to 256 characters
     * @type {string}
     * @memberof CreatePermissionDto
     */
    'alias'?: string;
}
/**
 * 
 * @export
 * @interface CreateRoleBindingDto
 */
export interface CreateRoleBindingDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateRoleBindingDto
     */
    'isCustom'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateRoleBindingDto
     */
    'roleId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateRoleBindingDto
     */
    'bindings': Array<string>;
}
/**
 * 
 * @export
 * @interface CreateRoleDto
 */
export interface CreateRoleDto {
    /**
     * Role id must follow the pattern: {systemPrefix}.{role} and contain a-z letters and hyphens where the systemPrefix size is 3 and role is between 2 and 30 characters.
     * @type {string}
     * @memberof CreateRoleDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoleDto
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateRoleDto
     */
    'permissions': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateRoleDto
     */
    'fixedBindings'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateSamlIdentityProviderDto
 */
export interface CreateSamlIdentityProviderDto {
    /**
     * 
     * @type {ExternalIdField}
     * @memberof CreateSamlIdentityProviderDto
     */
    'externalIdField': ExternalIdField;
    /**
     * 
     * @type {string}
     * @memberof CreateSamlIdentityProviderDto
     */
    'name': string;
    /**
     * 
     * @type {IdentityProviderType}
     * @memberof CreateSamlIdentityProviderDto
     */
    'type': IdentityProviderType;
    /**
     * 
     * @type {IdpUserType}
     * @memberof CreateSamlIdentityProviderDto
     */
    'userType': IdpUserType;
    /**
     * 
     * @type {CreateOidcIdentityProviderDtoExternalIdpLogoutConfig}
     * @memberof CreateSamlIdentityProviderDto
     */
    'externalIdpLogoutConfig'?: CreateOidcIdentityProviderDtoExternalIdpLogoutConfig;
    /**
     * 
     * @type {string}
     * @memberof CreateSamlIdentityProviderDto
     */
    'entityId': string;
    /**
     * Must be a valid url
     * @type {string}
     * @memberof CreateSamlIdentityProviderDto
     */
    'ssoUrl': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSamlIdentityProviderDto
     */
    'certificates': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateSamlIdentityProviderDto
     */
    'rpEntityId': string;
    /**
     * Space delimited, case sensitive list of ASCII string values that specifies whether the Authorization Server prompts the End-User for reauthentication and consent. The defined values are: none | login | consent | select_account For more info see: https://openid.net/specs/openid-connect-core-1_0.html#AuthRequest
     * @type {string}
     * @memberof CreateSamlIdentityProviderDto
     */
    'prompt'?: string;
}


/**
 * 
 * @export
 * @interface CreateSupportCaseBody
 */
export interface CreateSupportCaseBody {
    /**
     * The tenant id
     * @type {string}
     * @memberof CreateSupportCaseBody
     */
    'tenantId': string;
    /**
     * The title of the case
     * @type {string}
     * @memberof CreateSupportCaseBody
     */
    'title': string;
    /**
     * The description of the case
     * @type {string}
     * @memberof CreateSupportCaseBody
     */
    'description'?: string;
    /**
     * 
     * @type {AccessLevel}
     * @memberof CreateSupportCaseBody
     */
    'accessLevel': AccessLevel;
    /**
     * JIRA issues
     * @type {Array<string>}
     * @memberof CreateSupportCaseBody
     */
    'jiraIssueLinks'?: Array<string>;
    /**
     * The list of user profile ids
     * @type {Array<string>}
     * @memberof CreateSupportCaseBody
     */
    'assignees': Array<string>;
}


/**
 * 
 * @export
 * @interface CreateTenantDto
 */
export interface CreateTenantDto {
    /**
     * Full tenant name
     * @type {string}
     * @memberof CreateTenantDto
     */
    'name': string;
    /**
     * Tenant alias. Used as CNAME for tenant, for example tenant with alias extenda is accessable at https://extenda.hiiretail.com
     * @type {string}
     * @memberof CreateTenantDto
     */
    'alias': string;
    /**
     * Admin user email
     * @type {string}
     * @memberof CreateTenantDto
     */
    'adminUser': string;
}
/**
 * 
 * @export
 * @interface CreateTestTenantDto
 */
export interface CreateTestTenantDto {
    /**
     * Full tenant name
     * @type {string}
     * @memberof CreateTestTenantDto
     */
    'name'?: string;
    /**
     * Admin user email
     * @type {string}
     * @memberof CreateTestTenantDto
     */
    'adminUser'?: string;
}
/**
 * 
 * @export
 * @interface CreateUserDto
 */
export interface CreateUserDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'type': CreateUserDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'scope': CreateUserDtoScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'operatorId'?: string;
}

export const CreateUserDtoTypeEnum = {
    Standalone: 'Standalone'
} as const;

export type CreateUserDtoTypeEnum = typeof CreateUserDtoTypeEnum[keyof typeof CreateUserDtoTypeEnum];
export const CreateUserDtoScopeEnum = {
    Staff: 'Staff'
} as const;

export type CreateUserDtoScopeEnum = typeof CreateUserDtoScopeEnum[keyof typeof CreateUserDtoScopeEnum];

/**
 * 
 * @export
 * @interface CustomRoleDto
 */
export interface CustomRoleDto {
    /**
     * 
     * @type {string}
     * @memberof CustomRoleDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CustomRoleDto
     */
    'name'?: string;
    /**
     * Only 100 permissions per role is allowed. The only exception is pos permissions, we allow up to 500 of them 
     * @type {Array<CustomRolePermissionDto>}
     * @memberof CustomRoleDto
     */
    'permissions': Array<CustomRolePermissionDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomRoleDto
     */
    'fixedBindings'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CustomRolePermissionDto
 */
export interface CustomRolePermissionDto {
    /**
     * Permission id must follow the pattern: {systemPrefix}.{resource}.{action} and contain a-z letters and hyphens where the systemPrefix size is 3, the resource and action parts are between 2 and 16 characters.
     * @type {string}
     * @memberof CustomRolePermissionDto
     */
    'id': string;
    /**
     * attributes must be an object with up to 10 props keys up to 40 chars values as strings up to 256 chars
     * @type {object}
     * @memberof CustomRolePermissionDto
     */
    'attributes'?: object;
    /**
     * 
     * @type {string}
     * @memberof CustomRolePermissionDto
     */
    'alias'?: string;
}
/**
 * 
 * @export
 * @interface CustomRolePermissionDtoWithoutAliasDto
 */
export interface CustomRolePermissionDtoWithoutAliasDto {
    /**
     * Permission id must follow the pattern: {systemPrefix}.{resource}.{action} and contain a-z letters and hyphens where the systemPrefix size is 3, the resource and action parts are between 2 and 16 characters.
     * @type {string}
     * @memberof CustomRolePermissionDtoWithoutAliasDto
     */
    'id': string;
    /**
     * attributes must be an object with up to 10 props keys up to 40 chars values as strings up to 256 chars
     * @type {object}
     * @memberof CustomRolePermissionDtoWithoutAliasDto
     */
    'attributes'?: object;
}
/**
 * Tenant status
 * @export
 * @enum {string}
 */

export const EntityStatus = {
    Creating: 'Creating',
    Created: 'Created',
    Updating: 'Updating'
} as const;

export type EntityStatus = typeof EntityStatus[keyof typeof EntityStatus];


/**
 * 
 * @export
 * @interface ExternalAppDto
 */
export interface ExternalAppDto {
    /**
     * 
     * @type {string}
     * @memberof ExternalAppDto
     */
    'id': string;
    /**
     * Application name
     * @type {string}
     * @memberof ExternalAppDto
     */
    'name': string;
    /**
     * Describes your app\'s most notable characteristics
     * @type {string}
     * @memberof ExternalAppDto
     */
    'description'?: string;
    /**
     * Key that will give you a possibility to exchange federated token on IAM token
     * @type {string}
     * @memberof ExternalAppDto
     */
    'apiKey': string;
    /**
     * 
     * @type {string}
     * @memberof ExternalAppDto
     */
    'lastUsedAt': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ExternalIdField = {
    Uid: 'Uid',
    Email: 'Email',
    PhoneNumber: 'PhoneNumber'
} as const;

export type ExternalIdField = typeof ExternalIdField[keyof typeof ExternalIdField];


/**
 * 
 * @export
 * @interface ExternalIdpLogoutConfig
 */
export interface ExternalIdpLogoutConfig {
    /**
     * If enabled, UI will redirect to externalIdpLogout.redirectUrl on logout
     * @type {boolean}
     * @memberof ExternalIdpLogoutConfig
     */
    'enabled': boolean;
    /**
     * Must be a valid url
     * @type {string}
     * @memberof ExternalIdpLogoutConfig
     */
    'redirectUrl': string;
}
/**
 * 
 * @export
 * @interface FederatedUserTokenRequestDto
 */
export interface FederatedUserTokenRequestDto {
    /**
     * An ID Token (JWT) from federated identity platform
     * @type {string}
     * @memberof FederatedUserTokenRequestDto
     */
    'federatedIdToken': string;
    /**
     * Provider Connection ID in IAM API
     * @type {string}
     * @memberof FederatedUserTokenRequestDto
     */
    'idProviderConnectionId': string;
    /**
     * 
     * @type {IdpUserType}
     * @memberof FederatedUserTokenRequestDto
     */
    'userScope': IdpUserType;
    /**
     * Nonce to be used in ID Token validation. Nonce must be unique for every token. Notice that you need to pass original nonce, but token should contain sha256 hash of original nonce
     * @type {string}
     * @memberof FederatedUserTokenRequestDto
     */
    'nonce'?: string;
}


/**
 * 
 * @export
 * @interface GenericProviderConfigDto
 */
export interface GenericProviderConfigDto {
    /**
     * Provider id. example - oidc.my-external-oidc-provider
     * @type {string}
     * @memberof GenericProviderConfigDto
     */
    'connectionId': string;
    /**
     * The name of the provider
     * @type {string}
     * @memberof GenericProviderConfigDto
     */
    'name': string | null;
    /**
     * 
     * @type {IdpUserType}
     * @memberof GenericProviderConfigDto
     */
    'userType': IdpUserType;
    /**
     * 
     * @type {IdentityProviderType}
     * @memberof GenericProviderConfigDto
     */
    'type': IdentityProviderType;
    /**
     * 
     * @type {string}
     * @memberof GenericProviderConfigDto
     */
    'prompt': string;
    /**
     * 
     * @type {OidcAuthFlow}
     * @memberof GenericProviderConfigDto
     */
    'flow': OidcAuthFlow;
    /**
     * 
     * @type {boolean}
     * @memberof GenericProviderConfigDto
     */
    'usePKCE': boolean;
}


/**
 * 
 * @export
 * @interface GroupDto
 */
export interface GroupDto {
    /**
     * 
     * @type {string}
     * @memberof GroupDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GroupDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GroupDto
     */
    'description'?: string;
    /**
     * 
     * @type {EntityStatus}
     * @memberof GroupDto
     */
    'status': EntityStatus;
}


/**
 * 
 * @export
 * @interface GroupLinkDto
 */
export interface GroupLinkDto {
    /**
     * 
     * @type {string}
     * @memberof GroupLinkDto
     */
    'documentId': string;
    /**
     * 
     * @type {string}
     * @memberof GroupLinkDto
     */
    'userGroupDocumentId': string;
}
/**
 * 
 * @export
 * @interface IamRefreshTokenRequestDto
 */
export interface IamRefreshTokenRequestDto {
    /**
     * An refresh Token (JWT) from federated identity platform
     * @type {string}
     * @memberof IamRefreshTokenRequestDto
     */
    'refreshToken': string;
    /**
     * 
     * @type {IdpUserType}
     * @memberof IamRefreshTokenRequestDto
     */
    'userType': IdpUserType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const IdentityProviderStatus = {
    Creating: 'Creating',
    Created: 'Created',
    Updating: 'Updating',
    Inactivating: 'Inactivating',
    Inactive: 'Inactive'
} as const;

export type IdentityProviderStatus = typeof IdentityProviderStatus[keyof typeof IdentityProviderStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const IdentityProviderType = {
    Oidc: 'Oidc',
    Saml: 'Saml'
} as const;

export type IdentityProviderType = typeof IdentityProviderType[keyof typeof IdentityProviderType];


/**
 * 
 * @export
 * @enum {string}
 */

export const IdpUserType = {
    Staff: 'Staff',
    Shoppers: 'Shoppers'
} as const;

export type IdpUserType = typeof IdpUserType[keyof typeof IdpUserType];


/**
 * 
 * @export
 * @interface InternalServerErrorDto
 */
export interface InternalServerErrorDto {
    /**
     * 
     * @type {number}
     * @memberof InternalServerErrorDto
     */
    'statusCode': InternalServerErrorDtoStatusCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof InternalServerErrorDto
     */
    'message': InternalServerErrorDtoMessageEnum;
}

export const InternalServerErrorDtoStatusCodeEnum = {
    NUMBER_500: 500
} as const;

export type InternalServerErrorDtoStatusCodeEnum = typeof InternalServerErrorDtoStatusCodeEnum[keyof typeof InternalServerErrorDtoStatusCodeEnum];
export const InternalServerErrorDtoMessageEnum = {
    InternalServerError: 'Internal Server Error'
} as const;

export type InternalServerErrorDtoMessageEnum = typeof InternalServerErrorDtoMessageEnum[keyof typeof InternalServerErrorDtoMessageEnum];

/**
 * 
 * @export
 * @interface InvalidPreconditionDto
 */
export interface InvalidPreconditionDto {
    /**
     * 
     * @type {number}
     * @memberof InvalidPreconditionDto
     */
    'statusCode': InvalidPreconditionDtoStatusCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof InvalidPreconditionDto
     */
    'message': InvalidPreconditionDtoMessageEnum;
    /**
     * 
     * @type {string}
     * @memberof InvalidPreconditionDto
     */
    'error': InvalidPreconditionDtoErrorEnum;
}

export const InvalidPreconditionDtoStatusCodeEnum = {
    NUMBER_409: 409
} as const;

export type InvalidPreconditionDtoStatusCodeEnum = typeof InvalidPreconditionDtoStatusCodeEnum[keyof typeof InvalidPreconditionDtoStatusCodeEnum];
export const InvalidPreconditionDtoMessageEnum = {
    InvalidPrecondition: 'Invalid precondition'
} as const;

export type InvalidPreconditionDtoMessageEnum = typeof InvalidPreconditionDtoMessageEnum[keyof typeof InvalidPreconditionDtoMessageEnum];
export const InvalidPreconditionDtoErrorEnum = {
    Conflict: 'Conflict'
} as const;

export type InvalidPreconditionDtoErrorEnum = typeof InvalidPreconditionDtoErrorEnum[keyof typeof InvalidPreconditionDtoErrorEnum];

/**
 * 
 * @export
 * @interface LoginConfigDto
 */
export interface LoginConfigDto {
    /**
     * HiiRetail tenant ID
     * @type {string}
     * @memberof LoginConfigDto
     */
    'tenantId': string;
    /**
     * Full tenant name
     * @type {string}
     * @memberof LoginConfigDto
     */
    'tenantName': string;
    /**
     * Identity Platform tenant for staff
     * @type {string}
     * @memberof LoginConfigDto
     */
    'staffTenantId': string | null;
    /**
     * Identity Platform tenant for shoppers
     * @type {string}
     * @memberof LoginConfigDto
     */
    'shopperTenantId': string | null;
    /**
     * OIDC Provider id. example - oidc.my-external-oidc-provider
     * @type {string}
     * @memberof LoginConfigDto
     */
    'primaryConnectionId'?: string;
    /**
     * Used to indicate the Tenant\'s default locale for purposes of localizing such       items as currency, date time format, or numerical representations.       The value must be a valid language-tag as defined in [RFC5646](https://tools.ietf.org/html/rfc5646).
     * @type {string}
     * @memberof LoginConfigDto
     */
    'defaultLocale'?: string;
    /**
     * Used to indicate the Tenant\'s default timezone. The value must be a valid timezone as defined in [tz database](https://en.wikipedia.org/wiki/List_of_tz_database_time_zones).
     * @type {string}
     * @memberof LoginConfigDto
     */
    'defaultTimezone'?: string;
    /**
     * Disables/Enables anonymous shoppers login
     * @type {boolean}
     * @memberof LoginConfigDto
     */
    'anonymousShoppersLoginDisabled'?: boolean;
    /**
     * Identity Providers, available for tenant
     * @type {Array<GenericProviderConfigDto>}
     * @memberof LoginConfigDto
     */
    'providers': Array<GenericProviderConfigDto>;
}
/**
 * 
 * @export
 * @interface NotFoundDto
 */
export interface NotFoundDto {
    /**
     * 
     * @type {number}
     * @memberof NotFoundDto
     */
    'statusCode': NotFoundDtoStatusCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof NotFoundDto
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof NotFoundDto
     */
    'error': NotFoundDtoErrorEnum;
}

export const NotFoundDtoStatusCodeEnum = {
    NUMBER_404: 404
} as const;

export type NotFoundDtoStatusCodeEnum = typeof NotFoundDtoStatusCodeEnum[keyof typeof NotFoundDtoStatusCodeEnum];
export const NotFoundDtoErrorEnum = {
    NotFound: 'Not Found'
} as const;

export type NotFoundDtoErrorEnum = typeof NotFoundDtoErrorEnum[keyof typeof NotFoundDtoErrorEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const OidcAuthFlow = {
    Implicit: 'Implicit',
    Code: 'Code'
} as const;

export type OidcAuthFlow = typeof OidcAuthFlow[keyof typeof OidcAuthFlow];


/**
 * 
 * @export
 * @interface OidcIdentityProviderDto
 */
export interface OidcIdentityProviderDto {
    /**
     * 
     * @type {string}
     * @memberof OidcIdentityProviderDto
     */
    'id': string;
    /**
     * 
     * @type {ExternalIdField}
     * @memberof OidcIdentityProviderDto
     */
    'externalIdField': ExternalIdField;
    /**
     * 
     * @type {string}
     * @memberof OidcIdentityProviderDto
     */
    'connectionId': string;
    /**
     * 
     * @type {string}
     * @memberof OidcIdentityProviderDto
     */
    'name': string;
    /**
     * 
     * @type {IdentityProviderStatus}
     * @memberof OidcIdentityProviderDto
     */
    'status': IdentityProviderStatus;
    /**
     * 
     * @type {IdentityProviderType}
     * @memberof OidcIdentityProviderDto
     */
    'type': IdentityProviderType;
    /**
     * 
     * @type {IdpUserType}
     * @memberof OidcIdentityProviderDto
     */
    'userType': IdpUserType;
    /**
     * Space delimited, case sensitive list of ASCII string values that specifies whether the Authorization Server prompts the End-User for reauthentication and consent. The defined values are: none | login | consent | select_account For more info see: https://openid.net/specs/openid-connect-core-1_0.html#AuthRequest
     * @type {string}
     * @memberof OidcIdentityProviderDto
     */
    'prompt': string;
    /**
     * 
     * @type {CreateOidcIdentityProviderDtoExternalIdpLogoutConfig}
     * @memberof OidcIdentityProviderDto
     */
    'externalIdpLogoutConfig'?: CreateOidcIdentityProviderDtoExternalIdpLogoutConfig;
    /**
     * 
     * @type {string}
     * @memberof OidcIdentityProviderDto
     */
    'clientId': string;
    /**
     * Must be a valid url
     * @type {string}
     * @memberof OidcIdentityProviderDto
     */
    'issuer': string;
    /**
     * 
     * @type {string}
     * @memberof OidcIdentityProviderDto
     */
    'callbackUrl': string;
    /**
     * 
     * @type {OidcAuthFlow}
     * @memberof OidcIdentityProviderDto
     */
    'flow'?: OidcAuthFlow;
    /**
     * 
     * @type {boolean}
     * @memberof OidcIdentityProviderDto
     */
    'usePKCE'?: boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const OrderByDirection = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type OrderByDirection = typeof OrderByDirection[keyof typeof OrderByDirection];


/**
 * 
 * @export
 * @interface PermissionDto
 */
export interface PermissionDto {
    /**
     * Permission id must follow the pattern: {systemPrefix}.{resource}.{action} and contain a-z letters and hyphens where the systemPrefix size is 3, the resource and action parts are between 2 and 16 characters.
     * @type {string}
     * @memberof PermissionDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PermissionDto
     */
    'description'?: string;
    /**
     * optional alias for the permission, up to 256 characters
     * @type {string}
     * @memberof PermissionDto
     */
    'alias'?: string;
}
/**
 * 
 * @export
 * @interface RefreshTokenDto
 */
export interface RefreshTokenDto {
    /**
     * 
     * @type {string}
     * @memberof RefreshTokenDto
     */
    'iamToken': string;
    /**
     * 
     * @type {string}
     * @memberof RefreshTokenDto
     */
    'refreshToken': string;
    /**
     * 
     * @type {number}
     * @memberof RefreshTokenDto
     */
    'expiresIn': number;
}
/**
 * 
 * @export
 * @interface RequesterDto
 */
export interface RequesterDto {
    /**
     * The user id
     * @type {string}
     * @memberof RequesterDto
     */
    'id': string;
    /**
     * 
     * @type {RequesterType}
     * @memberof RequesterDto
     */
    'type': RequesterType;
}


/**
 * The type of the requester
 * @export
 * @enum {string}
 */

export const RequesterType = {
    User: 'user',
    Oauth2Client: 'oauth2-client',
    Internal: 'internal'
} as const;

export type RequesterType = typeof RequesterType[keyof typeof RequesterType];


/**
 * 
 * @export
 * @interface ResetPasswordDto
 */
export interface ResetPasswordDto {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordDto
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface ResourceDto
 */
export interface ResourceDto {
    /**
     * 
     * @type {string}
     * @memberof ResourceDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ResourceDto
     */
    'name': string;
    /**
     * 
     * @type {SetResourceDtoProps}
     * @memberof ResourceDto
     */
    'props'?: SetResourceDtoProps;
}
/**
 * 
 * @export
 * @interface RoleBindingDto
 */
export interface RoleBindingDto {
    /**
     * 
     * @type {boolean}
     * @memberof RoleBindingDto
     */
    'isCustom'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleBindingDto
     */
    'roleId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RoleBindingDto
     */
    'fixedBindings'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RoleBindingDto
     */
    'bindings': Array<string>;
}
/**
 * 
 * @export
 * @interface RoleDto
 */
export interface RoleDto {
    /**
     * Role id must follow the pattern: {systemPrefix}.{role} and contain a-z letters and hyphens where the systemPrefix size is 3 and role is between 2 and 30 characters.
     * @type {string}
     * @memberof RoleDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RoleDto
     */
    'permissions': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RoleDto
     */
    'fixedBindings'?: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RoleFields = {
    Name: 'name'
} as const;

export type RoleFields = typeof RoleFields[keyof typeof RoleFields];


/**
 * 
 * @export
 * @interface SamlIdentityProviderDto
 */
export interface SamlIdentityProviderDto {
    /**
     * 
     * @type {string}
     * @memberof SamlIdentityProviderDto
     */
    'id': string;
    /**
     * 
     * @type {ExternalIdField}
     * @memberof SamlIdentityProviderDto
     */
    'externalIdField': ExternalIdField;
    /**
     * 
     * @type {string}
     * @memberof SamlIdentityProviderDto
     */
    'connectionId': string;
    /**
     * 
     * @type {string}
     * @memberof SamlIdentityProviderDto
     */
    'name': string;
    /**
     * 
     * @type {IdentityProviderStatus}
     * @memberof SamlIdentityProviderDto
     */
    'status': IdentityProviderStatus;
    /**
     * 
     * @type {IdentityProviderType}
     * @memberof SamlIdentityProviderDto
     */
    'type': IdentityProviderType;
    /**
     * 
     * @type {IdpUserType}
     * @memberof SamlIdentityProviderDto
     */
    'userType': IdpUserType;
    /**
     * Space delimited, case sensitive list of ASCII string values that specifies whether the Authorization Server prompts the End-User for reauthentication and consent. The defined values are: none | login | consent | select_account For more info see: https://openid.net/specs/openid-connect-core-1_0.html#AuthRequest
     * @type {string}
     * @memberof SamlIdentityProviderDto
     */
    'prompt': string;
    /**
     * 
     * @type {CreateOidcIdentityProviderDtoExternalIdpLogoutConfig}
     * @memberof SamlIdentityProviderDto
     */
    'externalIdpLogoutConfig'?: CreateOidcIdentityProviderDtoExternalIdpLogoutConfig;
    /**
     * 
     * @type {string}
     * @memberof SamlIdentityProviderDto
     */
    'entityId': string;
    /**
     * Must be a valid url
     * @type {string}
     * @memberof SamlIdentityProviderDto
     */
    'ssoUrl': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SamlIdentityProviderDto
     */
    'certificates': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SamlIdentityProviderDto
     */
    'rpEntityId': string;
    /**
     * 
     * @type {string}
     * @memberof SamlIdentityProviderDto
     */
    'callbackUrl': string;
}


/**
 * 
 * @export
 * @interface SetAnonymousShoppersLoginDisabledDto
 */
export interface SetAnonymousShoppersLoginDisabledDto {
    /**
     * Disables/Enables anonymous shoppers login
     * @type {boolean}
     * @memberof SetAnonymousShoppersLoginDisabledDto
     */
    'anonymousShoppersLoginDisabled'?: boolean;
}
/**
 * 
 * @export
 * @interface SetDefaultLocaleDto
 */
export interface SetDefaultLocaleDto {
    /**
     * Used to indicate the Tenant\'s default locale for purposes of localizing such       items as currency, date time format, or numerical representations.       The value must be a valid language-tag as defined in [RFC5646](https://tools.ietf.org/html/rfc5646).
     * @type {string}
     * @memberof SetDefaultLocaleDto
     */
    'defaultLocale'?: string;
}
/**
 * 
 * @export
 * @interface SetDefaultTimezoneDto
 */
export interface SetDefaultTimezoneDto {
    /**
     * Used to indicate the Tenant\'s default timezone. The value must be a valid timezone as defined in [tz database](https://en.wikipedia.org/wiki/List_of_tz_database_time_zones).
     * @type {string}
     * @memberof SetDefaultTimezoneDto
     */
    'defaultTimezone'?: string;
}
/**
 * 
 * @export
 * @interface SetPrimaryConnectionIdDto
 */
export interface SetPrimaryConnectionIdDto {
    /**
     * Provider id. example - oidc.my-external-oidc-provider
     * @type {string}
     * @memberof SetPrimaryConnectionIdDto
     */
    'connectionId'?: string;
}
/**
 * 
 * @export
 * @interface SetResourceDto
 */
export interface SetResourceDto {
    /**
     * 
     * @type {string}
     * @memberof SetResourceDto
     */
    'name': string;
    /**
     * 
     * @type {SetResourceDtoProps}
     * @memberof SetResourceDto
     */
    'props'?: SetResourceDtoProps;
}
/**
 * @type SetResourceDtoProps
 * @export
 */
export type SetResourceDtoProps = Array | boolean | number | object | string;

/**
 * 
 * @export
 * @enum {string}
 */

export const SortBy = {
    Name: 'name'
} as const;

export type SortBy = typeof SortBy[keyof typeof SortBy];


/**
 * 
 * @export
 * @interface StandaloneUserTokenRequestDto
 */
export interface StandaloneUserTokenRequestDto {
    /**
     * User email
     * @type {string}
     * @memberof StandaloneUserTokenRequestDto
     */
    'email': string;
    /**
     * User password
     * @type {string}
     * @memberof StandaloneUserTokenRequestDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface SupportCaseAuditLogDto
 */
export interface SupportCaseAuditLogDto {
    /**
     * The id of the case audit log
     * @type {string}
     * @memberof SupportCaseAuditLogDto
     */
    'id': string;
    /**
     * The action of the case audit log
     * @type {string}
     * @memberof SupportCaseAuditLogDto
     */
    'action': string;
    /**
     * The support case id
     * @type {string}
     * @memberof SupportCaseAuditLogDto
     */
    'supportCaseId': string;
    /**
     * The payload of the case audit log
     * @type {object}
     * @memberof SupportCaseAuditLogDto
     */
    'payload': object;
    /**
     * 
     * @type {SupportCaseAuditLogDtoRequester}
     * @memberof SupportCaseAuditLogDto
     */
    'requester': SupportCaseAuditLogDtoRequester;
    /**
     * The creation date of the case audit log. ISO 8601 format
     * @type {string}
     * @memberof SupportCaseAuditLogDto
     */
    'createdAt': string;
}
/**
 * The requester id performing the action
 * @export
 * @interface SupportCaseAuditLogDtoRequester
 */
export interface SupportCaseAuditLogDtoRequester {
    /**
     * The user id
     * @type {string}
     * @memberof SupportCaseAuditLogDtoRequester
     */
    'id': string;
    /**
     * 
     * @type {RequesterType}
     * @memberof SupportCaseAuditLogDtoRequester
     */
    'type': RequesterType;
}


/**
 * 
 * @export
 * @interface SupportCaseCredentialsDto
 */
export interface SupportCaseCredentialsDto {
    /**
     * The case id
     * @type {number}
     * @memberof SupportCaseCredentialsDto
     */
    'id': number;
    /**
     * The username of the user
     * @type {string}
     * @memberof SupportCaseCredentialsDto
     */
    'username': string;
    /**
     * The password of the user
     * @type {string}
     * @memberof SupportCaseCredentialsDto
     */
    'password': string;
    /**
     * The login url
     * @type {string}
     * @memberof SupportCaseCredentialsDto
     */
    'loginUrl': string;
    /**
     * The support case id
     * @type {string}
     * @memberof SupportCaseCredentialsDto
     */
    'supportCaseId': string;
    /**
     * The time it was first fetched. ISO 8601 format
     * @type {string}
     * @memberof SupportCaseCredentialsDto
     */
    'fetchedAt'?: string;
}
/**
 * 
 * @export
 * @interface SupportCaseDto
 */
export interface SupportCaseDto {
    /**
     * The case id
     * @type {number}
     * @memberof SupportCaseDto
     */
    'id': number;
    /**
     * The tenant id
     * @type {string}
     * @memberof SupportCaseDto
     */
    'tenantId': string;
    /**
     * 
     * @type {SupportCaseStatus}
     * @memberof SupportCaseDto
     */
    'status': SupportCaseStatus;
    /**
     * The title of the case
     * @type {string}
     * @memberof SupportCaseDto
     */
    'title': string;
    /**
     * The description of the case
     * @type {string}
     * @memberof SupportCaseDto
     */
    'description'?: string;
    /**
     * 
     * @type {AccessLevel}
     * @memberof SupportCaseDto
     */
    'accessLevel': AccessLevel;
    /**
     * JIRA issues
     * @type {Array<string>}
     * @memberof SupportCaseDto
     */
    'jiraIssueLinks'?: Array<string>;
    /**
     * 
     * @type {SupportCaseDtoCreatedBy}
     * @memberof SupportCaseDto
     */
    'createdBy': SupportCaseDtoCreatedBy;
    /**
     * The creation date of the case
     * @type {string}
     * @memberof SupportCaseDto
     */
    'createdAt': string;
    /**
     * The date of the case last action
     * @type {string}
     * @memberof SupportCaseDto
     */
    'decidedAt'?: string;
    /**
     * 
     * @type {SupportCaseDtoDecidedBy}
     * @memberof SupportCaseDto
     */
    'decidedBy'?: SupportCaseDtoDecidedBy;
    /**
     * The list of user profile ids
     * @type {Array<string>}
     * @memberof SupportCaseDto
     */
    'assignees': Array<string>;
}


/**
 * Taken from the auth context - the user who created the case
 * @export
 * @interface SupportCaseDtoCreatedBy
 */
export interface SupportCaseDtoCreatedBy {
    /**
     * The user id
     * @type {string}
     * @memberof SupportCaseDtoCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {RequesterType}
     * @memberof SupportCaseDtoCreatedBy
     */
    'type': RequesterType;
}


/**
 * Taken from the auth context - the user who make a decision on the support case (tanant admin)
 * @export
 * @interface SupportCaseDtoDecidedBy
 */
export interface SupportCaseDtoDecidedBy {
    /**
     * The user id
     * @type {string}
     * @memberof SupportCaseDtoDecidedBy
     */
    'id': string;
    /**
     * 
     * @type {RequesterType}
     * @memberof SupportCaseDtoDecidedBy
     */
    'type': RequesterType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SupportCaseStatus = {
    Pending: 'Pending',
    Accepted: 'Accepted',
    Rejected: 'Rejected',
    Expired: 'Expired',
    Archived: 'Archived',
    Closed: 'Closed'
} as const;

export type SupportCaseStatus = typeof SupportCaseStatus[keyof typeof SupportCaseStatus];


/**
 * 
 * @export
 * @interface TenantDto
 */
export interface TenantDto {
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    'id': string;
    /**
     * Full tenant name
     * @type {string}
     * @memberof TenantDto
     */
    'name': string;
    /**
     * Tenant alias. Used as CNAME for tenant, for example tenant with alias extenda is accessable at https://extenda.hiiretail.com
     * @type {string}
     * @memberof TenantDto
     */
    'alias': string;
    /**
     * Admin user email
     * @type {string}
     * @memberof TenantDto
     */
    'adminUser': string;
    /**
     * 
     * @type {EntityStatus}
     * @memberof TenantDto
     */
    'status': EntityStatus;
    /**
     * Tenant Id in Google Identity Platform Shoppers project
     * @type {string}
     * @memberof TenantDto
     */
    'shopperTenantId': string;
    /**
     * Tenant Id in Google Identity Platform Staff project
     * @type {string}
     * @memberof TenantDto
     */
    'staffTenantId': string;
    /**
     * If true, this is test tenant, used as test env for prod tenant
     * @type {boolean}
     * @memberof TenantDto
     */
    'isTestTenant': boolean;
}


/**
 * 
 * @export
 * @interface TestIamTokenDto
 */
export interface TestIamTokenDto {
    /**
     * 
     * @type {string}
     * @memberof TestIamTokenDto
     */
    'iamToken': string;
    /**
     * 
     * @type {string}
     * @memberof TestIamTokenDto
     */
    'refreshToken': string;
    /**
     * 
     * @type {number}
     * @memberof TestIamTokenDto
     */
    'expiresIn': number;
}
/**
 * 
 * @export
 * @interface UpdateCustomRoleDto
 */
export interface UpdateCustomRoleDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomRoleDto
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateCustomRoleDto
     */
    'fixedBindings'?: Array<string>;
    /**
     * Only 100 permissions per role is allowed. The only exception is pos permissions, we allow up to 500 of them 
     * @type {Array<CustomRolePermissionDtoWithoutAliasDto>}
     * @memberof UpdateCustomRoleDto
     */
    'permissions'?: Array<CustomRolePermissionDtoWithoutAliasDto>;
}
/**
 * 
 * @export
 * @interface UpdateExternalAppDto
 */
export interface UpdateExternalAppDto {
    /**
     * Application name
     * @type {string}
     * @memberof UpdateExternalAppDto
     */
    'name': string;
    /**
     * Describes your app\'s most notable characteristics
     * @type {string}
     * @memberof UpdateExternalAppDto
     */
    'description'?: string;
    /**
     * Key that will give you a possibility to exchange federated token on IAM token
     * @type {string}
     * @memberof UpdateExternalAppDto
     */
    'apiKey': string;
}
/**
 * 
 * @export
 * @interface UpdateGroupDto
 */
export interface UpdateGroupDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface UpdateOidcIdentityProviderDto
 */
export interface UpdateOidcIdentityProviderDto {
    /**
     * 
     * @type {ExternalIdField}
     * @memberof UpdateOidcIdentityProviderDto
     */
    'externalIdField': ExternalIdField;
    /**
     * 
     * @type {string}
     * @memberof UpdateOidcIdentityProviderDto
     */
    'name': string;
    /**
     * 
     * @type {CreateOidcIdentityProviderDtoExternalIdpLogoutConfig}
     * @memberof UpdateOidcIdentityProviderDto
     */
    'externalIdpLogoutConfig'?: CreateOidcIdentityProviderDtoExternalIdpLogoutConfig;
    /**
     * 
     * @type {string}
     * @memberof UpdateOidcIdentityProviderDto
     */
    'clientId': string;
    /**
     * Must be a valid url
     * @type {string}
     * @memberof UpdateOidcIdentityProviderDto
     */
    'issuer': string;
    /**
     * Space delimited, case sensitive list of ASCII string values that specifies whether the Authorization Server prompts the End-User for reauthentication and consent. The defined values are: none | login | consent | select_account For more info see: https://openid.net/specs/openid-connect-core-1_0.html#AuthRequest
     * @type {string}
     * @memberof UpdateOidcIdentityProviderDto
     */
    'prompt'?: string;
    /**
     * 
     * @type {OidcAuthFlow}
     * @memberof UpdateOidcIdentityProviderDto
     */
    'flow'?: OidcAuthFlow;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOidcIdentityProviderDto
     */
    'usePKCE'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateOidcIdentityProviderDto
     */
    'clientSecret'?: string;
}


/**
 * 
 * @export
 * @interface UpdatePermissionDto
 */
export interface UpdatePermissionDto {
    /**
     * 
     * @type {string}
     * @memberof UpdatePermissionDto
     */
    'description'?: string;
    /**
     * optional alias for the permission, up to 256 characters
     * @type {string}
     * @memberof UpdatePermissionDto
     */
    'alias'?: string;
}
/**
 * 
 * @export
 * @interface UpdateRoleBindingDto
 */
export interface UpdateRoleBindingDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateRoleBindingDto
     */
    'bindings': Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateRoleDto
 */
export interface UpdateRoleDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleDto
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateRoleDto
     */
    'permissions'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateRoleDto
     */
    'fixedBindings'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateSamlIdentityProviderDto
 */
export interface UpdateSamlIdentityProviderDto {
    /**
     * 
     * @type {ExternalIdField}
     * @memberof UpdateSamlIdentityProviderDto
     */
    'externalIdField': ExternalIdField;
    /**
     * 
     * @type {string}
     * @memberof UpdateSamlIdentityProviderDto
     */
    'name': string;
    /**
     * 
     * @type {CreateOidcIdentityProviderDtoExternalIdpLogoutConfig}
     * @memberof UpdateSamlIdentityProviderDto
     */
    'externalIdpLogoutConfig'?: CreateOidcIdentityProviderDtoExternalIdpLogoutConfig;
    /**
     * 
     * @type {string}
     * @memberof UpdateSamlIdentityProviderDto
     */
    'entityId': string;
    /**
     * Must be a valid url
     * @type {string}
     * @memberof UpdateSamlIdentityProviderDto
     */
    'ssoUrl': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSamlIdentityProviderDto
     */
    'certificates': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateSamlIdentityProviderDto
     */
    'rpEntityId': string;
    /**
     * Space delimited, case sensitive list of ASCII string values that specifies whether the Authorization Server prompts the End-User for reauthentication and consent. The defined values are: none | login | consent | select_account For more info see: https://openid.net/specs/openid-connect-core-1_0.html#AuthRequest
     * @type {string}
     * @memberof UpdateSamlIdentityProviderDto
     */
    'prompt'?: string;
}


/**
 * 
 * @export
 * @interface UpdateTenantDto
 */
export interface UpdateTenantDto {
    /**
     * Full tenant name
     * @type {string}
     * @memberof UpdateTenantDto
     */
    'name'?: string;
    /**
     * Tenant alias. Used as CNAME for tenant, for example tenant with alias extenda is accessable at https://extenda.hiiretail.com
     * @type {string}
     * @memberof UpdateTenantDto
     */
    'alias'?: string;
    /**
     * Admin user email
     * @type {string}
     * @memberof UpdateTenantDto
     */
    'adminUser'?: string;
}
/**
 * 
 * @export
 * @interface UpdateUserDto
 */
export interface UpdateUserDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'name'?: string;
    /**
     * Required for standalone users and federated users where externalIdField = Email
     * @type {string}
     * @memberof UpdateUserDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'operatorId'?: string | null;
    /**
     * 
     * @type {UpdateUserStatus}
     * @memberof UpdateUserDto
     */
    'status'?: UpdateUserStatus;
}


/**
 * 
 * @export
 * @interface UpdateUserProfileDto
 */
export interface UpdateUserProfileDto {
    /**
     * Required for standalone users and federated users where externalIdField = Email
     * @type {string}
     * @memberof UpdateUserProfileDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserProfileDto
     */
    'displayName'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const UpdateUserStatus = {
    Active: 'Active',
    Inactive: 'Inactive'
} as const;

export type UpdateUserStatus = typeof UpdateUserStatus[keyof typeof UpdateUserStatus];


/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'name': string;
    /**
     * Required for standalone users and federated users where externalIdField = Email
     * @type {string}
     * @memberof UserDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'externalId': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'externalProviderId': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'userProfileExternalUserId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'googleIdentity': string;
    /**
     * 
     * @type {IdpUserType}
     * @memberof UserDto
     */
    'scope': IdpUserType;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'standaloneId': string | null;
    /**
     * 
     * @type {UserStatus}
     * @memberof UserDto
     */
    'status': UserStatus;
    /**
     * 
     * @type {UserType}
     * @memberof UserDto
     */
    'type': UserType;
    /**
     * Id of this user\'s profile in User Profile service
     * @type {string}
     * @memberof UserDto
     */
    'userProfileId': string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'operatorId': string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const UserStatus = {
    Creating: 'Creating',
    Created: 'Created',
    Linking: 'Linking',
    Updating: 'Updating',
    Deactivating: 'Deactivating',
    Inactive: 'Inactive',
    Activating: 'Activating'
} as const;

export type UserStatus = typeof UserStatus[keyof typeof UserStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const UserType = {
    Federated: 'Federated',
    Standalone: 'Standalone'
} as const;

export type UserType = typeof UserType[keyof typeof UserType];



/**
 * CustomRolesApi - axios parameter creator
 * @export
 */
export const CustomRolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create custom role.
         * @summary Create custom role.
         * @param {string} tenantId 
         * @param {CreateCustomRoleDto} createCustomRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomRole: async (tenantId: string, createCustomRoleDto: CreateCustomRoleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createCustomRole', 'tenantId', tenantId)
            // verify required parameter 'createCustomRoleDto' is not null or undefined
            assertParamExists('createCustomRole', 'createCustomRoleDto', createCustomRoleDto)
            const localVarPath = `/api/v1/tenants/{tenantId}/roles`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCustomRoleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete custom role by id
         * @summary Delete custom role by id
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomRole: async (tenantId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('deleteCustomRole', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCustomRole', 'id', id)
            const localVarPath = `/api/v1/tenants/{tenantId}/roles/{id}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get custom role by id\'.
         * @summary Get custom role by id
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomRole: async (tenantId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getCustomRole', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCustomRole', 'id', id)
            const localVarPath = `/api/v1/tenants/{tenantId}/roles/{id}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List custom roles\'.
         * @summary List custom roles
         * @param {string} tenantId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomRoles: async (tenantId: string, limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getCustomRoles', 'tenantId', tenantId)
            const localVarPath = `/api/v1/tenants/{tenantId}/roles`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update custom role by id
         * @summary Update custom role by id
         * @param {string} tenantId 
         * @param {string} id 
         * @param {UpdateCustomRoleDto} updateCustomRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomRole: async (tenantId: string, id: string, updateCustomRoleDto: UpdateCustomRoleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateCustomRole', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCustomRole', 'id', id)
            // verify required parameter 'updateCustomRoleDto' is not null or undefined
            assertParamExists('updateCustomRole', 'updateCustomRoleDto', updateCustomRoleDto)
            const localVarPath = `/api/v1/tenants/{tenantId}/roles/{id}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomRoleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomRolesApi - functional programming interface
 * @export
 */
export const CustomRolesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomRolesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create custom role.
         * @summary Create custom role.
         * @param {string} tenantId 
         * @param {CreateCustomRoleDto} createCustomRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomRole(tenantId: string, createCustomRoleDto: CreateCustomRoleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomRoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomRole(tenantId, createCustomRoleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete custom role by id
         * @summary Delete custom role by id
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomRole(tenantId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomRole(tenantId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get custom role by id\'.
         * @summary Get custom role by id
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomRole(tenantId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomRoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomRole(tenantId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List custom roles\'.
         * @summary List custom roles
         * @param {string} tenantId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomRoles(tenantId: string, limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomRoleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomRoles(tenantId, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update custom role by id
         * @summary Update custom role by id
         * @param {string} tenantId 
         * @param {string} id 
         * @param {UpdateCustomRoleDto} updateCustomRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomRole(tenantId: string, id: string, updateCustomRoleDto: UpdateCustomRoleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomRole(tenantId, id, updateCustomRoleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomRolesApi - factory interface
 * @export
 */
export const CustomRolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomRolesApiFp(configuration)
    return {
        /**
         * Create custom role.
         * @summary Create custom role.
         * @param {string} tenantId 
         * @param {CreateCustomRoleDto} createCustomRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomRole(tenantId: string, createCustomRoleDto: CreateCustomRoleDto, options?: any): AxiosPromise<CustomRoleDto> {
            return localVarFp.createCustomRole(tenantId, createCustomRoleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete custom role by id
         * @summary Delete custom role by id
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomRole(tenantId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteCustomRole(tenantId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get custom role by id\'.
         * @summary Get custom role by id
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomRole(tenantId: string, id: string, options?: any): AxiosPromise<CustomRoleDto> {
            return localVarFp.getCustomRole(tenantId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * List custom roles\'.
         * @summary List custom roles
         * @param {string} tenantId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomRoles(tenantId: string, limit?: number, offset?: number, options?: any): AxiosPromise<Array<CustomRoleDto>> {
            return localVarFp.getCustomRoles(tenantId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Update custom role by id
         * @summary Update custom role by id
         * @param {string} tenantId 
         * @param {string} id 
         * @param {UpdateCustomRoleDto} updateCustomRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomRole(tenantId: string, id: string, updateCustomRoleDto: UpdateCustomRoleDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateCustomRole(tenantId, id, updateCustomRoleDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomRolesApi - object-oriented interface
 * @export
 * @class CustomRolesApi
 * @extends {BaseAPI}
 */
export class CustomRolesApi extends BaseAPI {
    /**
     * Create custom role.
     * @summary Create custom role.
     * @param {string} tenantId 
     * @param {CreateCustomRoleDto} createCustomRoleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomRolesApi
     */
    public createCustomRole(tenantId: string, createCustomRoleDto: CreateCustomRoleDto, options?: AxiosRequestConfig) {
        return CustomRolesApiFp(this.configuration).createCustomRole(tenantId, createCustomRoleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete custom role by id
     * @summary Delete custom role by id
     * @param {string} tenantId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomRolesApi
     */
    public deleteCustomRole(tenantId: string, id: string, options?: AxiosRequestConfig) {
        return CustomRolesApiFp(this.configuration).deleteCustomRole(tenantId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get custom role by id\'.
     * @summary Get custom role by id
     * @param {string} tenantId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomRolesApi
     */
    public getCustomRole(tenantId: string, id: string, options?: AxiosRequestConfig) {
        return CustomRolesApiFp(this.configuration).getCustomRole(tenantId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List custom roles\'.
     * @summary List custom roles
     * @param {string} tenantId 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomRolesApi
     */
    public getCustomRoles(tenantId: string, limit?: number, offset?: number, options?: AxiosRequestConfig) {
        return CustomRolesApiFp(this.configuration).getCustomRoles(tenantId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update custom role by id
     * @summary Update custom role by id
     * @param {string} tenantId 
     * @param {string} id 
     * @param {UpdateCustomRoleDto} updateCustomRoleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomRolesApi
     */
    public updateCustomRole(tenantId: string, id: string, updateCustomRoleDto: UpdateCustomRoleDto, options?: AxiosRequestConfig) {
        return CustomRolesApiFp(this.configuration).updateCustomRole(tenantId, id, updateCustomRoleDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ExternalAppApi - axios parameter creator
 * @export
 */
export const ExternalAppApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create an external application.
         * @param {string} tenantId 
         * @param {CreateExternalAppDto} createExternalAppDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExternalApp: async (tenantId: string, createExternalAppDto: CreateExternalAppDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createExternalApp', 'tenantId', tenantId)
            // verify required parameter 'createExternalAppDto' is not null or undefined
            assertParamExists('createExternalApp', 'createExternalAppDto', createExternalAppDto)
            const localVarPath = `/api/v1/tenants/{tenantId}/external-apps`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createExternalAppDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete external application.
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExternalApp: async (id: string, tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteExternalApp', 'id', id)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('deleteExternalApp', 'tenantId', tenantId)
            const localVarPath = `/api/v1/tenants/{tenantId}/external-apps/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get external application by id.
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalAppById: async (id: string, tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getExternalAppById', 'id', id)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getExternalAppById', 'tenantId', tenantId)
            const localVarPath = `/api/v1/tenants/{tenantId}/external-apps/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of external applications.
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalApps: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getExternalApps', 'tenantId', tenantId)
            const localVarPath = `/api/v1/tenants/{tenantId}/external-apps`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update external application.
         * @param {string} id 
         * @param {string} tenantId 
         * @param {UpdateExternalAppDto} updateExternalAppDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExternalApp: async (id: string, tenantId: string, updateExternalAppDto: UpdateExternalAppDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateExternalApp', 'id', id)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateExternalApp', 'tenantId', tenantId)
            // verify required parameter 'updateExternalAppDto' is not null or undefined
            assertParamExists('updateExternalApp', 'updateExternalAppDto', updateExternalAppDto)
            const localVarPath = `/api/v1/tenants/{tenantId}/external-apps/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateExternalAppDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalAppApi - functional programming interface
 * @export
 */
export const ExternalAppApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExternalAppApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create an external application.
         * @param {string} tenantId 
         * @param {CreateExternalAppDto} createExternalAppDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExternalApp(tenantId: string, createExternalAppDto: CreateExternalAppDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalAppDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExternalApp(tenantId, createExternalAppDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete external application.
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteExternalApp(id: string, tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteExternalApp(id, tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get external application by id.
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExternalAppById(id: string, tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalAppDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExternalAppById(id, tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a list of external applications.
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExternalApps(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExternalAppDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExternalApps(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update external application.
         * @param {string} id 
         * @param {string} tenantId 
         * @param {UpdateExternalAppDto} updateExternalAppDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExternalApp(id: string, tenantId: string, updateExternalAppDto: UpdateExternalAppDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExternalApp(id, tenantId, updateExternalAppDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ExternalAppApi - factory interface
 * @export
 */
export const ExternalAppApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExternalAppApiFp(configuration)
    return {
        /**
         * 
         * @summary Create an external application.
         * @param {string} tenantId 
         * @param {CreateExternalAppDto} createExternalAppDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExternalApp(tenantId: string, createExternalAppDto: CreateExternalAppDto, options?: any): AxiosPromise<ExternalAppDto> {
            return localVarFp.createExternalApp(tenantId, createExternalAppDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete external application.
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExternalApp(id: string, tenantId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteExternalApp(id, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get external application by id.
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalAppById(id: string, tenantId: string, options?: any): AxiosPromise<ExternalAppDto> {
            return localVarFp.getExternalAppById(id, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of external applications.
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalApps(tenantId: string, options?: any): AxiosPromise<Array<ExternalAppDto>> {
            return localVarFp.getExternalApps(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update external application.
         * @param {string} id 
         * @param {string} tenantId 
         * @param {UpdateExternalAppDto} updateExternalAppDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExternalApp(id: string, tenantId: string, updateExternalAppDto: UpdateExternalAppDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateExternalApp(id, tenantId, updateExternalAppDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExternalAppApi - object-oriented interface
 * @export
 * @class ExternalAppApi
 * @extends {BaseAPI}
 */
export class ExternalAppApi extends BaseAPI {
    /**
     * 
     * @summary Create an external application.
     * @param {string} tenantId 
     * @param {CreateExternalAppDto} createExternalAppDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalAppApi
     */
    public createExternalApp(tenantId: string, createExternalAppDto: CreateExternalAppDto, options?: AxiosRequestConfig) {
        return ExternalAppApiFp(this.configuration).createExternalApp(tenantId, createExternalAppDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete external application.
     * @param {string} id 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalAppApi
     */
    public deleteExternalApp(id: string, tenantId: string, options?: AxiosRequestConfig) {
        return ExternalAppApiFp(this.configuration).deleteExternalApp(id, tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get external application by id.
     * @param {string} id 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalAppApi
     */
    public getExternalAppById(id: string, tenantId: string, options?: AxiosRequestConfig) {
        return ExternalAppApiFp(this.configuration).getExternalAppById(id, tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of external applications.
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalAppApi
     */
    public getExternalApps(tenantId: string, options?: AxiosRequestConfig) {
        return ExternalAppApiFp(this.configuration).getExternalApps(tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update external application.
     * @param {string} id 
     * @param {string} tenantId 
     * @param {UpdateExternalAppDto} updateExternalAppDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalAppApi
     */
    public updateExternalApp(id: string, tenantId: string, updateExternalAppDto: UpdateExternalAppDto, options?: AxiosRequestConfig) {
        return ExternalAppApiFp(this.configuration).updateExternalApp(id, tenantId, updateExternalAppDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GroupsApi - axios parameter creator
 * @export
 */
export const GroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create group.
         * @summary Create group.
         * @param {string} tenantId 
         * @param {CreateGroupDto} createGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup: async (tenantId: string, createGroupDto: CreateGroupDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createGroup', 'tenantId', tenantId)
            // verify required parameter 'createGroupDto' is not null or undefined
            assertParamExists('createGroup', 'createGroupDto', createGroupDto)
            const localVarPath = `/api/v1/tenants/{tenantId}/groups`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGroupDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete group by id.
         * @summary Delete group by id.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup: async (tenantId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('deleteGroup', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteGroup', 'id', id)
            const localVarPath = `/api/v1/tenants/{tenantId}/groups/{id}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get group by id.
         * @summary Get group by id.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroup: async (tenantId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getGroup', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getGroup', 'id', id)
            const localVarPath = `/api/v1/tenants/{tenantId}/groups/{id}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all users in group.
         * @summary Get all users in group.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersInGroup: async (tenantId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getUsersInGroup', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUsersInGroup', 'id', id)
            const localVarPath = `/api/v1/tenants/{tenantId}/groups/{id}/users`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List groups.
         * @summary List groups.
         * @param {string} tenantId 
         * @param {string} [searchString] searchString only works, when sortBy is selected and searches in &#x60;sortBy&#x60; field
         * @param {OrderByDirection} [direction] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortBy} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGroups: async (tenantId: string, searchString?: string, direction?: OrderByDirection, limit?: number, offset?: number, sortBy?: SortBy, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('listGroups', 'tenantId', tenantId)
            const localVarPath = `/api/v1/tenants/{tenantId}/groups`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unassign role from group by id.
         * @summary Unassign role from group by id.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {string} roleId 
         * @param {boolean} [isCustom] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignRole: async (tenantId: string, id: string, roleId: string, isCustom?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('unassignRole', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unassignRole', 'id', id)
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('unassignRole', 'roleId', roleId)
            const localVarPath = `/api/v1/tenants/{tenantId}/groups/{id}/roles/{roleId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isCustom !== undefined) {
                localVarQueryParameter['isCustom'] = isCustom;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update group by id.
         * @summary Update group by id.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {UpdateGroupDto} updateGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroup: async (tenantId: string, id: string, updateGroupDto: UpdateGroupDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateGroup', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateGroup', 'id', id)
            // verify required parameter 'updateGroupDto' is not null or undefined
            assertParamExists('updateGroup', 'updateGroupDto', updateGroupDto)
            const localVarPath = `/api/v1/tenants/{tenantId}/groups/{id}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGroupDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GroupsApi - functional programming interface
 * @export
 */
export const GroupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GroupsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create group.
         * @summary Create group.
         * @param {string} tenantId 
         * @param {CreateGroupDto} createGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGroup(tenantId: string, createGroupDto: CreateGroupDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGroup(tenantId, createGroupDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete group by id.
         * @summary Delete group by id.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGroup(tenantId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGroup(tenantId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get group by id.
         * @summary Get group by id.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroup(tenantId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroup(tenantId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all users in group.
         * @summary Get all users in group.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersInGroup(tenantId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersInGroup(tenantId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List groups.
         * @summary List groups.
         * @param {string} tenantId 
         * @param {string} [searchString] searchString only works, when sortBy is selected and searches in &#x60;sortBy&#x60; field
         * @param {OrderByDirection} [direction] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortBy} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGroups(tenantId: string, searchString?: string, direction?: OrderByDirection, limit?: number, offset?: number, sortBy?: SortBy, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGroups(tenantId, searchString, direction, limit, offset, sortBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Unassign role from group by id.
         * @summary Unassign role from group by id.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {string} roleId 
         * @param {boolean} [isCustom] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unassignRole(tenantId: string, id: string, roleId: string, isCustom?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unassignRole(tenantId, id, roleId, isCustom, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update group by id.
         * @summary Update group by id.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {UpdateGroupDto} updateGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGroup(tenantId: string, id: string, updateGroupDto: UpdateGroupDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGroup(tenantId, id, updateGroupDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GroupsApi - factory interface
 * @export
 */
export const GroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GroupsApiFp(configuration)
    return {
        /**
         * Create group.
         * @summary Create group.
         * @param {string} tenantId 
         * @param {CreateGroupDto} createGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup(tenantId: string, createGroupDto: CreateGroupDto, options?: any): AxiosPromise<GroupDto> {
            return localVarFp.createGroup(tenantId, createGroupDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete group by id.
         * @summary Delete group by id.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup(tenantId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteGroup(tenantId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get group by id.
         * @summary Get group by id.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroup(tenantId: string, id: string, options?: any): AxiosPromise<GroupDto> {
            return localVarFp.getGroup(tenantId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all users in group.
         * @summary Get all users in group.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersInGroup(tenantId: string, id: string, options?: any): AxiosPromise<Array<UserDto>> {
            return localVarFp.getUsersInGroup(tenantId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * List groups.
         * @summary List groups.
         * @param {string} tenantId 
         * @param {string} [searchString] searchString only works, when sortBy is selected and searches in &#x60;sortBy&#x60; field
         * @param {OrderByDirection} [direction] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortBy} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGroups(tenantId: string, searchString?: string, direction?: OrderByDirection, limit?: number, offset?: number, sortBy?: SortBy, options?: any): AxiosPromise<Array<GroupDto>> {
            return localVarFp.listGroups(tenantId, searchString, direction, limit, offset, sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * Unassign role from group by id.
         * @summary Unassign role from group by id.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {string} roleId 
         * @param {boolean} [isCustom] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignRole(tenantId: string, id: string, roleId: string, isCustom?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.unassignRole(tenantId, id, roleId, isCustom, options).then((request) => request(axios, basePath));
        },
        /**
         * Update group by id.
         * @summary Update group by id.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {UpdateGroupDto} updateGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroup(tenantId: string, id: string, updateGroupDto: UpdateGroupDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateGroup(tenantId, id, updateGroupDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GroupsApi - object-oriented interface
 * @export
 * @class GroupsApi
 * @extends {BaseAPI}
 */
export class GroupsApi extends BaseAPI {
    /**
     * Create group.
     * @summary Create group.
     * @param {string} tenantId 
     * @param {CreateGroupDto} createGroupDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    public createGroup(tenantId: string, createGroupDto: CreateGroupDto, options?: AxiosRequestConfig) {
        return GroupsApiFp(this.configuration).createGroup(tenantId, createGroupDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete group by id.
     * @summary Delete group by id.
     * @param {string} tenantId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    public deleteGroup(tenantId: string, id: string, options?: AxiosRequestConfig) {
        return GroupsApiFp(this.configuration).deleteGroup(tenantId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get group by id.
     * @summary Get group by id.
     * @param {string} tenantId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    public getGroup(tenantId: string, id: string, options?: AxiosRequestConfig) {
        return GroupsApiFp(this.configuration).getGroup(tenantId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all users in group.
     * @summary Get all users in group.
     * @param {string} tenantId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    public getUsersInGroup(tenantId: string, id: string, options?: AxiosRequestConfig) {
        return GroupsApiFp(this.configuration).getUsersInGroup(tenantId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List groups.
     * @summary List groups.
     * @param {string} tenantId 
     * @param {string} [searchString] searchString only works, when sortBy is selected and searches in &#x60;sortBy&#x60; field
     * @param {OrderByDirection} [direction] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {SortBy} [sortBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    public listGroups(tenantId: string, searchString?: string, direction?: OrderByDirection, limit?: number, offset?: number, sortBy?: SortBy, options?: AxiosRequestConfig) {
        return GroupsApiFp(this.configuration).listGroups(tenantId, searchString, direction, limit, offset, sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unassign role from group by id.
     * @summary Unassign role from group by id.
     * @param {string} tenantId 
     * @param {string} id 
     * @param {string} roleId 
     * @param {boolean} [isCustom] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    public unassignRole(tenantId: string, id: string, roleId: string, isCustom?: boolean, options?: AxiosRequestConfig) {
        return GroupsApiFp(this.configuration).unassignRole(tenantId, id, roleId, isCustom, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update group by id.
     * @summary Update group by id.
     * @param {string} tenantId 
     * @param {string} id 
     * @param {UpdateGroupDto} updateGroupDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    public updateGroup(tenantId: string, id: string, updateGroupDto: UpdateGroupDto, options?: AxiosRequestConfig) {
        return GroupsApiFp(this.configuration).updateGroup(tenantId, id, updateGroupDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GroupsV2Api - axios parameter creator
 * @export
 */
export const GroupsV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Assign role to group.
         * @summary Assign role to group.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {CreateRoleBindingDto} createRoleBindingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignRole: async (tenantId: string, id: string, createRoleBindingDto: CreateRoleBindingDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('assignRole', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assignRole', 'id', id)
            // verify required parameter 'createRoleBindingDto' is not null or undefined
            assertParamExists('assignRole', 'createRoleBindingDto', createRoleBindingDto)
            const localVarPath = `/api/v2/tenants/{tenantId}/groups/{id}/roles`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRoleBindingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get group roles.
         * @summary Get group roles.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupRoles: async (tenantId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getGroupRoles', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getGroupRoles', 'id', id)
            const localVarPath = `/api/v2/tenants/{tenantId}/groups/{id}/roles`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update role bindings in group.
         * @summary Update role bindings in group.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {string} roleId 
         * @param {UpdateRoleBindingDto} updateRoleBindingDto 
         * @param {boolean} [isCustom] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroupRole: async (tenantId: string, id: string, roleId: string, updateRoleBindingDto: UpdateRoleBindingDto, isCustom?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateGroupRole', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateGroupRole', 'id', id)
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('updateGroupRole', 'roleId', roleId)
            // verify required parameter 'updateRoleBindingDto' is not null or undefined
            assertParamExists('updateGroupRole', 'updateRoleBindingDto', updateRoleBindingDto)
            const localVarPath = `/api/v2/tenants/{tenantId}/groups/{id}/roles/{roleId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isCustom !== undefined) {
                localVarQueryParameter['isCustom'] = isCustom;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRoleBindingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GroupsV2Api - functional programming interface
 * @export
 */
export const GroupsV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GroupsV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * Assign role to group.
         * @summary Assign role to group.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {CreateRoleBindingDto} createRoleBindingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignRole(tenantId: string, id: string, createRoleBindingDto: CreateRoleBindingDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignRole(tenantId, id, createRoleBindingDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get group roles.
         * @summary Get group roles.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupRoles(tenantId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleBindingDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupRoles(tenantId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update role bindings in group.
         * @summary Update role bindings in group.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {string} roleId 
         * @param {UpdateRoleBindingDto} updateRoleBindingDto 
         * @param {boolean} [isCustom] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGroupRole(tenantId: string, id: string, roleId: string, updateRoleBindingDto: UpdateRoleBindingDto, isCustom?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGroupRole(tenantId, id, roleId, updateRoleBindingDto, isCustom, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GroupsV2Api - factory interface
 * @export
 */
export const GroupsV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GroupsV2ApiFp(configuration)
    return {
        /**
         * Assign role to group.
         * @summary Assign role to group.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {CreateRoleBindingDto} createRoleBindingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignRole(tenantId: string, id: string, createRoleBindingDto: CreateRoleBindingDto, options?: any): AxiosPromise<void> {
            return localVarFp.assignRole(tenantId, id, createRoleBindingDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Get group roles.
         * @summary Get group roles.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupRoles(tenantId: string, id: string, options?: any): AxiosPromise<Array<RoleBindingDto>> {
            return localVarFp.getGroupRoles(tenantId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update role bindings in group.
         * @summary Update role bindings in group.
         * @param {string} tenantId 
         * @param {string} id 
         * @param {string} roleId 
         * @param {UpdateRoleBindingDto} updateRoleBindingDto 
         * @param {boolean} [isCustom] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroupRole(tenantId: string, id: string, roleId: string, updateRoleBindingDto: UpdateRoleBindingDto, isCustom?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.updateGroupRole(tenantId, id, roleId, updateRoleBindingDto, isCustom, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GroupsV2Api - object-oriented interface
 * @export
 * @class GroupsV2Api
 * @extends {BaseAPI}
 */
export class GroupsV2Api extends BaseAPI {
    /**
     * Assign role to group.
     * @summary Assign role to group.
     * @param {string} tenantId 
     * @param {string} id 
     * @param {CreateRoleBindingDto} createRoleBindingDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsV2Api
     */
    public assignRole(tenantId: string, id: string, createRoleBindingDto: CreateRoleBindingDto, options?: AxiosRequestConfig) {
        return GroupsV2ApiFp(this.configuration).assignRole(tenantId, id, createRoleBindingDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get group roles.
     * @summary Get group roles.
     * @param {string} tenantId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsV2Api
     */
    public getGroupRoles(tenantId: string, id: string, options?: AxiosRequestConfig) {
        return GroupsV2ApiFp(this.configuration).getGroupRoles(tenantId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update role bindings in group.
     * @summary Update role bindings in group.
     * @param {string} tenantId 
     * @param {string} id 
     * @param {string} roleId 
     * @param {UpdateRoleBindingDto} updateRoleBindingDto 
     * @param {boolean} [isCustom] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsV2Api
     */
    public updateGroupRole(tenantId: string, id: string, roleId: string, updateRoleBindingDto: UpdateRoleBindingDto, isCustom?: boolean, options?: AxiosRequestConfig) {
        return GroupsV2ApiFp(this.configuration).updateGroupRole(tenantId, id, roleId, updateRoleBindingDto, isCustom, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IamTokenApi - axios parameter creator
 * @export
 */
export const IamTokenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Exchange IAM ID token for custom firebase token. Custom can be used to trigger new auth session with firebase sdk given iam token
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCustomToken: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('generateCustomToken', 'tenantId', tenantId)
            const localVarPath = `/api/v1/tenants/{tenantId}/iam-token/custom`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Exchange federated ID token user token for IAM ID token
         * @param {string} tenantId 
         * @param {FederatedUserTokenRequestDto} federatedUserTokenRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTestFederatedToken: async (tenantId: string, federatedUserTokenRequestDto: FederatedUserTokenRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('generateTestFederatedToken', 'tenantId', tenantId)
            // verify required parameter 'federatedUserTokenRequestDto' is not null or undefined
            assertParamExists('generateTestFederatedToken', 'federatedUserTokenRequestDto', federatedUserTokenRequestDto)
            const localVarPath = `/api/v1/tenants/{tenantId}/iam-token/users/federated`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(federatedUserTokenRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Exchange email+password for IAM ID token. WARNING: Use of standalone users is not recommended. Be aware, you cannot generate IAM token for the same ID token twice!!
         * @param {string} tenantId 
         * @param {StandaloneUserTokenRequestDto} standaloneUserTokenRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTestStandaloneToken: async (tenantId: string, standaloneUserTokenRequestDto: StandaloneUserTokenRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('generateTestStandaloneToken', 'tenantId', tenantId)
            // verify required parameter 'standaloneUserTokenRequestDto' is not null or undefined
            assertParamExists('generateTestStandaloneToken', 'standaloneUserTokenRequestDto', standaloneUserTokenRequestDto)
            const localVarPath = `/api/v1/tenants/{tenantId}/iam-token/users/standalone`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(standaloneUserTokenRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Exchange refresh token user token for IAM ID token
         * @param {string} tenantId 
         * @param {IamRefreshTokenRequestDto} iamRefreshTokenRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshIamToken: async (tenantId: string, iamRefreshTokenRequestDto: IamRefreshTokenRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('refreshIamToken', 'tenantId', tenantId)
            // verify required parameter 'iamRefreshTokenRequestDto' is not null or undefined
            assertParamExists('refreshIamToken', 'iamRefreshTokenRequestDto', iamRefreshTokenRequestDto)
            const localVarPath = `/api/v1/tenants/{tenantId}/iam-token/refresh`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iamRefreshTokenRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IamTokenApi - functional programming interface
 * @export
 */
export const IamTokenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IamTokenApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Exchange IAM ID token for custom firebase token. Custom can be used to trigger new auth session with firebase sdk given iam token
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateCustomToken(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestIamTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateCustomToken(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Exchange federated ID token user token for IAM ID token
         * @param {string} tenantId 
         * @param {FederatedUserTokenRequestDto} federatedUserTokenRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateTestFederatedToken(tenantId: string, federatedUserTokenRequestDto: FederatedUserTokenRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestIamTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateTestFederatedToken(tenantId, federatedUserTokenRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Exchange email+password for IAM ID token. WARNING: Use of standalone users is not recommended. Be aware, you cannot generate IAM token for the same ID token twice!!
         * @param {string} tenantId 
         * @param {StandaloneUserTokenRequestDto} standaloneUserTokenRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateTestStandaloneToken(tenantId: string, standaloneUserTokenRequestDto: StandaloneUserTokenRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestIamTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateTestStandaloneToken(tenantId, standaloneUserTokenRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Exchange refresh token user token for IAM ID token
         * @param {string} tenantId 
         * @param {IamRefreshTokenRequestDto} iamRefreshTokenRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshIamToken(tenantId: string, iamRefreshTokenRequestDto: IamRefreshTokenRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RefreshTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshIamToken(tenantId, iamRefreshTokenRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IamTokenApi - factory interface
 * @export
 */
export const IamTokenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IamTokenApiFp(configuration)
    return {
        /**
         * 
         * @summary Exchange IAM ID token for custom firebase token. Custom can be used to trigger new auth session with firebase sdk given iam token
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCustomToken(tenantId: string, options?: any): AxiosPromise<TestIamTokenDto> {
            return localVarFp.generateCustomToken(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Exchange federated ID token user token for IAM ID token
         * @param {string} tenantId 
         * @param {FederatedUserTokenRequestDto} federatedUserTokenRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTestFederatedToken(tenantId: string, federatedUserTokenRequestDto: FederatedUserTokenRequestDto, options?: any): AxiosPromise<TestIamTokenDto> {
            return localVarFp.generateTestFederatedToken(tenantId, federatedUserTokenRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Exchange email+password for IAM ID token. WARNING: Use of standalone users is not recommended. Be aware, you cannot generate IAM token for the same ID token twice!!
         * @param {string} tenantId 
         * @param {StandaloneUserTokenRequestDto} standaloneUserTokenRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTestStandaloneToken(tenantId: string, standaloneUserTokenRequestDto: StandaloneUserTokenRequestDto, options?: any): AxiosPromise<TestIamTokenDto> {
            return localVarFp.generateTestStandaloneToken(tenantId, standaloneUserTokenRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Exchange refresh token user token for IAM ID token
         * @param {string} tenantId 
         * @param {IamRefreshTokenRequestDto} iamRefreshTokenRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshIamToken(tenantId: string, iamRefreshTokenRequestDto: IamRefreshTokenRequestDto, options?: any): AxiosPromise<RefreshTokenDto> {
            return localVarFp.refreshIamToken(tenantId, iamRefreshTokenRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IamTokenApi - object-oriented interface
 * @export
 * @class IamTokenApi
 * @extends {BaseAPI}
 */
export class IamTokenApi extends BaseAPI {
    /**
     * 
     * @summary Exchange IAM ID token for custom firebase token. Custom can be used to trigger new auth session with firebase sdk given iam token
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IamTokenApi
     */
    public generateCustomToken(tenantId: string, options?: AxiosRequestConfig) {
        return IamTokenApiFp(this.configuration).generateCustomToken(tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Exchange federated ID token user token for IAM ID token
     * @param {string} tenantId 
     * @param {FederatedUserTokenRequestDto} federatedUserTokenRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IamTokenApi
     */
    public generateTestFederatedToken(tenantId: string, federatedUserTokenRequestDto: FederatedUserTokenRequestDto, options?: AxiosRequestConfig) {
        return IamTokenApiFp(this.configuration).generateTestFederatedToken(tenantId, federatedUserTokenRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Exchange email+password for IAM ID token. WARNING: Use of standalone users is not recommended. Be aware, you cannot generate IAM token for the same ID token twice!!
     * @param {string} tenantId 
     * @param {StandaloneUserTokenRequestDto} standaloneUserTokenRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IamTokenApi
     */
    public generateTestStandaloneToken(tenantId: string, standaloneUserTokenRequestDto: StandaloneUserTokenRequestDto, options?: AxiosRequestConfig) {
        return IamTokenApiFp(this.configuration).generateTestStandaloneToken(tenantId, standaloneUserTokenRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Exchange refresh token user token for IAM ID token
     * @param {string} tenantId 
     * @param {IamRefreshTokenRequestDto} iamRefreshTokenRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IamTokenApi
     */
    public refreshIamToken(tenantId: string, iamRefreshTokenRequestDto: IamRefreshTokenRequestDto, options?: AxiosRequestConfig) {
        return IamTokenApiFp(this.configuration).refreshIamToken(tenantId, iamRefreshTokenRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LoginConfigApi - axios parameter creator
 * @export
 */
export const LoginConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns tenant id in firestore and GIP + available identity providers
         * @summary Get login config
         * @param {string} tenantAlias Tenant alias
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfig: async (tenantAlias: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantAlias' is not null or undefined
            assertParamExists('getConfig', 'tenantAlias', tenantAlias)
            const localVarPath = `/api/v1/login-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (tenantAlias !== undefined) {
                localVarQueryParameter['tenantAlias'] = tenantAlias;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disables/Enables anonymous shopper login. If flag in the body not specified, value will be removed from config & login will be enabled.
         * @param {SetAnonymousShoppersLoginDisabledDto} setAnonymousShoppersLoginDisabledDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAnonymousShoppersLoginDisabled: async (setAnonymousShoppersLoginDisabledDto: SetAnonymousShoppersLoginDisabledDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setAnonymousShoppersLoginDisabledDto' is not null or undefined
            assertParamExists('setAnonymousShoppersLoginDisabled', 'setAnonymousShoppersLoginDisabledDto', setAnonymousShoppersLoginDisabledDto)
            const localVarPath = `/api/v1/login-config:setAnonymousShoppersLoginDisabled`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setAnonymousShoppersLoginDisabledDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Endpoint lets the tenant set default locale. If `defaultLocale` is not passed, default locale will be deleted
         * @param {SetDefaultLocaleDto} setDefaultLocaleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultLanguage: async (setDefaultLocaleDto: SetDefaultLocaleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setDefaultLocaleDto' is not null or undefined
            assertParamExists('setDefaultLanguage', 'setDefaultLocaleDto', setDefaultLocaleDto)
            const localVarPath = `/api/v1/login-config:setDefaultLocale`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setDefaultLocaleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Endpoint lets the tenant set default timezone. If `defaultTimezone` is not passed, default timezone will be deleted
         * @param {SetDefaultTimezoneDto} setDefaultTimezoneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultTimezone: async (setDefaultTimezoneDto: SetDefaultTimezoneDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setDefaultTimezoneDto' is not null or undefined
            assertParamExists('setDefaultTimezone', 'setDefaultTimezoneDto', setDefaultTimezoneDto)
            const localVarPath = `/api/v1/login-config:setDefaultTimezone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setDefaultTimezoneDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Try set primary connection id. If provided id does not match any of the providers or is not provided at all, no changes are made.
         * @param {SetPrimaryConnectionIdDto} setPrimaryConnectionIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrimaryConnectionId: async (setPrimaryConnectionIdDto: SetPrimaryConnectionIdDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setPrimaryConnectionIdDto' is not null or undefined
            assertParamExists('setPrimaryConnectionId', 'setPrimaryConnectionIdDto', setPrimaryConnectionIdDto)
            const localVarPath = `/api/v1/login-config:setPrimaryConnectionId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setPrimaryConnectionIdDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoginConfigApi - functional programming interface
 * @export
 */
export const LoginConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoginConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns tenant id in firestore and GIP + available identity providers
         * @summary Get login config
         * @param {string} tenantAlias Tenant alias
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfig(tenantAlias: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfig(tenantAlias, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Disables/Enables anonymous shopper login. If flag in the body not specified, value will be removed from config & login will be enabled.
         * @param {SetAnonymousShoppersLoginDisabledDto} setAnonymousShoppersLoginDisabledDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAnonymousShoppersLoginDisabled(setAnonymousShoppersLoginDisabledDto: SetAnonymousShoppersLoginDisabledDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAnonymousShoppersLoginDisabled(setAnonymousShoppersLoginDisabledDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Endpoint lets the tenant set default locale. If `defaultLocale` is not passed, default locale will be deleted
         * @param {SetDefaultLocaleDto} setDefaultLocaleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDefaultLanguage(setDefaultLocaleDto: SetDefaultLocaleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDefaultLanguage(setDefaultLocaleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Endpoint lets the tenant set default timezone. If `defaultTimezone` is not passed, default timezone will be deleted
         * @param {SetDefaultTimezoneDto} setDefaultTimezoneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDefaultTimezone(setDefaultTimezoneDto: SetDefaultTimezoneDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDefaultTimezone(setDefaultTimezoneDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Try set primary connection id. If provided id does not match any of the providers or is not provided at all, no changes are made.
         * @param {SetPrimaryConnectionIdDto} setPrimaryConnectionIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPrimaryConnectionId(setPrimaryConnectionIdDto: SetPrimaryConnectionIdDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPrimaryConnectionId(setPrimaryConnectionIdDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LoginConfigApi - factory interface
 * @export
 */
export const LoginConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoginConfigApiFp(configuration)
    return {
        /**
         * Returns tenant id in firestore and GIP + available identity providers
         * @summary Get login config
         * @param {string} tenantAlias Tenant alias
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfig(tenantAlias: string, options?: any): AxiosPromise<LoginConfigDto> {
            return localVarFp.getConfig(tenantAlias, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disables/Enables anonymous shopper login. If flag in the body not specified, value will be removed from config & login will be enabled.
         * @param {SetAnonymousShoppersLoginDisabledDto} setAnonymousShoppersLoginDisabledDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAnonymousShoppersLoginDisabled(setAnonymousShoppersLoginDisabledDto: SetAnonymousShoppersLoginDisabledDto, options?: any): AxiosPromise<void> {
            return localVarFp.setAnonymousShoppersLoginDisabled(setAnonymousShoppersLoginDisabledDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Endpoint lets the tenant set default locale. If `defaultLocale` is not passed, default locale will be deleted
         * @param {SetDefaultLocaleDto} setDefaultLocaleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultLanguage(setDefaultLocaleDto: SetDefaultLocaleDto, options?: any): AxiosPromise<void> {
            return localVarFp.setDefaultLanguage(setDefaultLocaleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Endpoint lets the tenant set default timezone. If `defaultTimezone` is not passed, default timezone will be deleted
         * @param {SetDefaultTimezoneDto} setDefaultTimezoneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultTimezone(setDefaultTimezoneDto: SetDefaultTimezoneDto, options?: any): AxiosPromise<void> {
            return localVarFp.setDefaultTimezone(setDefaultTimezoneDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Try set primary connection id. If provided id does not match any of the providers or is not provided at all, no changes are made.
         * @param {SetPrimaryConnectionIdDto} setPrimaryConnectionIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrimaryConnectionId(setPrimaryConnectionIdDto: SetPrimaryConnectionIdDto, options?: any): AxiosPromise<void> {
            return localVarFp.setPrimaryConnectionId(setPrimaryConnectionIdDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoginConfigApi - object-oriented interface
 * @export
 * @class LoginConfigApi
 * @extends {BaseAPI}
 */
export class LoginConfigApi extends BaseAPI {
    /**
     * Returns tenant id in firestore and GIP + available identity providers
     * @summary Get login config
     * @param {string} tenantAlias Tenant alias
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginConfigApi
     */
    public getConfig(tenantAlias: string, options?: AxiosRequestConfig) {
        return LoginConfigApiFp(this.configuration).getConfig(tenantAlias, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disables/Enables anonymous shopper login. If flag in the body not specified, value will be removed from config & login will be enabled.
     * @param {SetAnonymousShoppersLoginDisabledDto} setAnonymousShoppersLoginDisabledDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginConfigApi
     */
    public setAnonymousShoppersLoginDisabled(setAnonymousShoppersLoginDisabledDto: SetAnonymousShoppersLoginDisabledDto, options?: AxiosRequestConfig) {
        return LoginConfigApiFp(this.configuration).setAnonymousShoppersLoginDisabled(setAnonymousShoppersLoginDisabledDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Endpoint lets the tenant set default locale. If `defaultLocale` is not passed, default locale will be deleted
     * @param {SetDefaultLocaleDto} setDefaultLocaleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginConfigApi
     */
    public setDefaultLanguage(setDefaultLocaleDto: SetDefaultLocaleDto, options?: AxiosRequestConfig) {
        return LoginConfigApiFp(this.configuration).setDefaultLanguage(setDefaultLocaleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Endpoint lets the tenant set default timezone. If `defaultTimezone` is not passed, default timezone will be deleted
     * @param {SetDefaultTimezoneDto} setDefaultTimezoneDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginConfigApi
     */
    public setDefaultTimezone(setDefaultTimezoneDto: SetDefaultTimezoneDto, options?: AxiosRequestConfig) {
        return LoginConfigApiFp(this.configuration).setDefaultTimezone(setDefaultTimezoneDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Try set primary connection id. If provided id does not match any of the providers or is not provided at all, no changes are made.
     * @param {SetPrimaryConnectionIdDto} setPrimaryConnectionIdDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginConfigApi
     */
    public setPrimaryConnectionId(setPrimaryConnectionIdDto: SetPrimaryConnectionIdDto, options?: AxiosRequestConfig) {
        return LoginConfigApiFp(this.configuration).setPrimaryConnectionId(setPrimaryConnectionIdDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OidcIdentityProvidersApi - axios parameter creator
 * @export
 */
export const OidcIdentityProvidersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create OIDC Identity provider
         * @param {string} tenantId 
         * @param {CreateOidcIdentityProviderDto} createOidcIdentityProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOidcProvider: async (tenantId: string, createOidcIdentityProviderDto: CreateOidcIdentityProviderDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createOidcProvider', 'tenantId', tenantId)
            // verify required parameter 'createOidcIdentityProviderDto' is not null or undefined
            assertParamExists('createOidcProvider', 'createOidcIdentityProviderDto', createOidcIdentityProviderDto)
            const localVarPath = `/api/v1/tenants/{tenantId}/providers-oidc`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOidcIdentityProviderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disable OIDC Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableOidcProvider: async (id: string, tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('disableOidcProvider', 'id', id)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('disableOidcProvider', 'tenantId', tenantId)
            const localVarPath = `/api/v1/tenants/{tenantId}/providers-oidc/{id}/disable`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enable OIDC Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableOidcProvider: async (id: string, tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('enableOidcProvider', 'id', id)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('enableOidcProvider', 'tenantId', tenantId)
            const localVarPath = `/api/v1/tenants/{tenantId}/providers-oidc/{id}/enable`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get OIDC Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOidcProvider: async (id: string, tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOidcProvider', 'id', id)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getOidcProvider', 'tenantId', tenantId)
            const localVarPath = `/api/v1/tenants/{tenantId}/providers-oidc/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List OIDC Identity Providers
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviders: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getProviders', 'tenantId', tenantId)
            const localVarPath = `/api/v1/tenants/{tenantId}/providers-oidc`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update OIDC Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {UpdateOidcIdentityProviderDto} updateOidcIdentityProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOidcProvider: async (id: string, tenantId: string, updateOidcIdentityProviderDto: UpdateOidcIdentityProviderDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOidcProvider', 'id', id)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateOidcProvider', 'tenantId', tenantId)
            // verify required parameter 'updateOidcIdentityProviderDto' is not null or undefined
            assertParamExists('updateOidcProvider', 'updateOidcIdentityProviderDto', updateOidcIdentityProviderDto)
            const localVarPath = `/api/v1/tenants/{tenantId}/providers-oidc/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOidcIdentityProviderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OidcIdentityProvidersApi - functional programming interface
 * @export
 */
export const OidcIdentityProvidersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OidcIdentityProvidersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create OIDC Identity provider
         * @param {string} tenantId 
         * @param {CreateOidcIdentityProviderDto} createOidcIdentityProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOidcProvider(tenantId: string, createOidcIdentityProviderDto: CreateOidcIdentityProviderDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OidcIdentityProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOidcProvider(tenantId, createOidcIdentityProviderDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Disable OIDC Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableOidcProvider(id: string, tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableOidcProvider(id, tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Enable OIDC Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableOidcProvider(id: string, tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableOidcProvider(id, tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get OIDC Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOidcProvider(id: string, tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OidcIdentityProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOidcProvider(id, tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List OIDC Identity Providers
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviders(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OidcIdentityProviderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviders(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update OIDC Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {UpdateOidcIdentityProviderDto} updateOidcIdentityProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOidcProvider(id: string, tenantId: string, updateOidcIdentityProviderDto: UpdateOidcIdentityProviderDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOidcProvider(id, tenantId, updateOidcIdentityProviderDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OidcIdentityProvidersApi - factory interface
 * @export
 */
export const OidcIdentityProvidersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OidcIdentityProvidersApiFp(configuration)
    return {
        /**
         * 
         * @summary Create OIDC Identity provider
         * @param {string} tenantId 
         * @param {CreateOidcIdentityProviderDto} createOidcIdentityProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOidcProvider(tenantId: string, createOidcIdentityProviderDto: CreateOidcIdentityProviderDto, options?: any): AxiosPromise<OidcIdentityProviderDto> {
            return localVarFp.createOidcProvider(tenantId, createOidcIdentityProviderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disable OIDC Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableOidcProvider(id: string, tenantId: string, options?: any): AxiosPromise<void> {
            return localVarFp.disableOidcProvider(id, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enable OIDC Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableOidcProvider(id: string, tenantId: string, options?: any): AxiosPromise<void> {
            return localVarFp.enableOidcProvider(id, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get OIDC Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOidcProvider(id: string, tenantId: string, options?: any): AxiosPromise<OidcIdentityProviderDto> {
            return localVarFp.getOidcProvider(id, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List OIDC Identity Providers
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviders(tenantId: string, options?: any): AxiosPromise<Array<OidcIdentityProviderDto>> {
            return localVarFp.getProviders(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update OIDC Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {UpdateOidcIdentityProviderDto} updateOidcIdentityProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOidcProvider(id: string, tenantId: string, updateOidcIdentityProviderDto: UpdateOidcIdentityProviderDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateOidcProvider(id, tenantId, updateOidcIdentityProviderDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OidcIdentityProvidersApi - object-oriented interface
 * @export
 * @class OidcIdentityProvidersApi
 * @extends {BaseAPI}
 */
export class OidcIdentityProvidersApi extends BaseAPI {
    /**
     * 
     * @summary Create OIDC Identity provider
     * @param {string} tenantId 
     * @param {CreateOidcIdentityProviderDto} createOidcIdentityProviderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OidcIdentityProvidersApi
     */
    public createOidcProvider(tenantId: string, createOidcIdentityProviderDto: CreateOidcIdentityProviderDto, options?: AxiosRequestConfig) {
        return OidcIdentityProvidersApiFp(this.configuration).createOidcProvider(tenantId, createOidcIdentityProviderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disable OIDC Identity Provider by id
     * @param {string} id 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OidcIdentityProvidersApi
     */
    public disableOidcProvider(id: string, tenantId: string, options?: AxiosRequestConfig) {
        return OidcIdentityProvidersApiFp(this.configuration).disableOidcProvider(id, tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enable OIDC Identity Provider by id
     * @param {string} id 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OidcIdentityProvidersApi
     */
    public enableOidcProvider(id: string, tenantId: string, options?: AxiosRequestConfig) {
        return OidcIdentityProvidersApiFp(this.configuration).enableOidcProvider(id, tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get OIDC Identity Provider by id
     * @param {string} id 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OidcIdentityProvidersApi
     */
    public getOidcProvider(id: string, tenantId: string, options?: AxiosRequestConfig) {
        return OidcIdentityProvidersApiFp(this.configuration).getOidcProvider(id, tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List OIDC Identity Providers
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OidcIdentityProvidersApi
     */
    public getProviders(tenantId: string, options?: AxiosRequestConfig) {
        return OidcIdentityProvidersApiFp(this.configuration).getProviders(tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update OIDC Identity Provider by id
     * @param {string} id 
     * @param {string} tenantId 
     * @param {UpdateOidcIdentityProviderDto} updateOidcIdentityProviderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OidcIdentityProvidersApi
     */
    public updateOidcProvider(id: string, tenantId: string, updateOidcIdentityProviderDto: UpdateOidcIdentityProviderDto, options?: AxiosRequestConfig) {
        return OidcIdentityProvidersApiFp(this.configuration).updateOidcProvider(id, tenantId, updateOidcIdentityProviderDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PermissionsApi - axios parameter creator
 * @export
 */
export const PermissionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create permission
         * @param {CreatePermissionDto} createPermissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPermission: async (createPermissionDto: CreatePermissionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPermissionDto' is not null or undefined
            assertParamExists('createPermission', 'createPermissionDto', createPermissionDto)
            const localVarPath = `/api/v1/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPermissionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get permission by id
         * @param {string} id Permission id must follow the pattern: {systemPrefix}.{resource}.{action} and contain a-z letters and hyphens where the systemPrefix size is 3, the resource and action parts are between 2 and 16 characters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermission: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPermission', 'id', id)
            const localVarPath = `/api/v1/permissions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update permission by id
         * @param {string} id Permission id must follow the pattern: {systemPrefix}.{resource}.{action} and contain a-z letters and hyphens where the systemPrefix size is 3, the resource and action parts are between 2 and 16 characters.
         * @param {UpdatePermissionDto} updatePermissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePermission: async (id: string, updatePermissionDto: UpdatePermissionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePermission', 'id', id)
            // verify required parameter 'updatePermissionDto' is not null or undefined
            assertParamExists('updatePermission', 'updatePermissionDto', updatePermissionDto)
            const localVarPath = `/api/v1/permissions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePermissionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PermissionsApi - functional programming interface
 * @export
 */
export const PermissionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PermissionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create permission
         * @param {CreatePermissionDto} createPermissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPermission(createPermissionDto: CreatePermissionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PermissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPermission(createPermissionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get permission by id
         * @param {string} id Permission id must follow the pattern: {systemPrefix}.{resource}.{action} and contain a-z letters and hyphens where the systemPrefix size is 3, the resource and action parts are between 2 and 16 characters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPermission(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PermissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPermission(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPermissions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PermissionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPermissions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update permission by id
         * @param {string} id Permission id must follow the pattern: {systemPrefix}.{resource}.{action} and contain a-z letters and hyphens where the systemPrefix size is 3, the resource and action parts are between 2 and 16 characters.
         * @param {UpdatePermissionDto} updatePermissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePermission(id: string, updatePermissionDto: UpdatePermissionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePermission(id, updatePermissionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PermissionsApi - factory interface
 * @export
 */
export const PermissionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PermissionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create permission
         * @param {CreatePermissionDto} createPermissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPermission(createPermissionDto: CreatePermissionDto, options?: any): AxiosPromise<PermissionDto> {
            return localVarFp.createPermission(createPermissionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get permission by id
         * @param {string} id Permission id must follow the pattern: {systemPrefix}.{resource}.{action} and contain a-z letters and hyphens where the systemPrefix size is 3, the resource and action parts are between 2 and 16 characters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermission(id: string, options?: any): AxiosPromise<PermissionDto> {
            return localVarFp.getPermission(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissions(options?: any): AxiosPromise<Array<PermissionDto>> {
            return localVarFp.getPermissions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update permission by id
         * @param {string} id Permission id must follow the pattern: {systemPrefix}.{resource}.{action} and contain a-z letters and hyphens where the systemPrefix size is 3, the resource and action parts are between 2 and 16 characters.
         * @param {UpdatePermissionDto} updatePermissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePermission(id: string, updatePermissionDto: UpdatePermissionDto, options?: any): AxiosPromise<void> {
            return localVarFp.updatePermission(id, updatePermissionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PermissionsApi - object-oriented interface
 * @export
 * @class PermissionsApi
 * @extends {BaseAPI}
 */
export class PermissionsApi extends BaseAPI {
    /**
     * 
     * @summary Create permission
     * @param {CreatePermissionDto} createPermissionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public createPermission(createPermissionDto: CreatePermissionDto, options?: AxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).createPermission(createPermissionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get permission by id
     * @param {string} id Permission id must follow the pattern: {systemPrefix}.{resource}.{action} and contain a-z letters and hyphens where the systemPrefix size is 3, the resource and action parts are between 2 and 16 characters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public getPermission(id: string, options?: AxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).getPermission(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List permissions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public getPermissions(options?: AxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).getPermissions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update permission by id
     * @param {string} id Permission id must follow the pattern: {systemPrefix}.{resource}.{action} and contain a-z letters and hyphens where the systemPrefix size is 3, the resource and action parts are between 2 and 16 characters.
     * @param {UpdatePermissionDto} updatePermissionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public updatePermission(id: string, updatePermissionDto: UpdatePermissionDto, options?: AxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).updatePermission(id, updatePermissionDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ResourcesApi - axios parameter creator
 * @export
 */
export const ResourcesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete resource by id
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResource: async (tenantId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('deleteResource', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteResource', 'id', id)
            const localVarPath = `/api/v1/tenants/{tenantId}/resources/{id}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get resource by id
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResource: async (tenantId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getResource', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getResource', 'id', id)
            const localVarPath = `/api/v1/tenants/{tenantId}/resources/{id}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List resources. If `permission` parameter is specified, endpoint will require - valid token that will have `permission` from query (bindings don\'t matter).
         * @param {string} tenantId 
         * @param {string} [permission] Optional permission to filter resources based on user token
         * @param {string} [type] Resource type, a prefix in resource id, like - bu, for Business units.
         * @param {Array<string>} [additionalBindings] Additional bindings to consider when listing resources. E.g. getting all bindings for type \&quot;ccc.kind\&quot;, while filtering out ones without the access to specific \&quot;bu\&quot; resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResources: async (tenantId: string, permission?: string, type?: string, additionalBindings?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getResources', 'tenantId', tenantId)
            const localVarPath = `/api/v1/tenants/{tenantId}/resources`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (additionalBindings) {
                localVarQueryParameter['additionalBindings'] = additionalBindings;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set resource
         * @param {string} tenantId 
         * @param {string} id 
         * @param {SetResourceDto} setResourceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setResource: async (tenantId: string, id: string, setResourceDto: SetResourceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('setResource', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setResource', 'id', id)
            // verify required parameter 'setResourceDto' is not null or undefined
            assertParamExists('setResource', 'setResourceDto', setResourceDto)
            const localVarPath = `/api/v1/tenants/{tenantId}/resources/{id}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setResourceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResourcesApi - functional programming interface
 * @export
 */
export const ResourcesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResourcesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete resource by id
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteResource(tenantId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteResource(tenantId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get resource by id
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResource(tenantId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResourceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResource(tenantId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List resources. If `permission` parameter is specified, endpoint will require - valid token that will have `permission` from query (bindings don\'t matter).
         * @param {string} tenantId 
         * @param {string} [permission] Optional permission to filter resources based on user token
         * @param {string} [type] Resource type, a prefix in resource id, like - bu, for Business units.
         * @param {Array<string>} [additionalBindings] Additional bindings to consider when listing resources. E.g. getting all bindings for type \&quot;ccc.kind\&quot;, while filtering out ones without the access to specific \&quot;bu\&quot; resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResources(tenantId: string, permission?: string, type?: string, additionalBindings?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ResourceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResources(tenantId, permission, type, additionalBindings, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set resource
         * @param {string} tenantId 
         * @param {string} id 
         * @param {SetResourceDto} setResourceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setResource(tenantId: string, id: string, setResourceDto: SetResourceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResourceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setResource(tenantId, id, setResourceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResourcesApi - factory interface
 * @export
 */
export const ResourcesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResourcesApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete resource by id
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResource(tenantId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteResource(tenantId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get resource by id
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResource(tenantId: string, id: string, options?: any): AxiosPromise<ResourceDto> {
            return localVarFp.getResource(tenantId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List resources. If `permission` parameter is specified, endpoint will require - valid token that will have `permission` from query (bindings don\'t matter).
         * @param {string} tenantId 
         * @param {string} [permission] Optional permission to filter resources based on user token
         * @param {string} [type] Resource type, a prefix in resource id, like - bu, for Business units.
         * @param {Array<string>} [additionalBindings] Additional bindings to consider when listing resources. E.g. getting all bindings for type \&quot;ccc.kind\&quot;, while filtering out ones without the access to specific \&quot;bu\&quot; resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResources(tenantId: string, permission?: string, type?: string, additionalBindings?: Array<string>, options?: any): AxiosPromise<Array<ResourceDto>> {
            return localVarFp.getResources(tenantId, permission, type, additionalBindings, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set resource
         * @param {string} tenantId 
         * @param {string} id 
         * @param {SetResourceDto} setResourceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setResource(tenantId: string, id: string, setResourceDto: SetResourceDto, options?: any): AxiosPromise<ResourceDto> {
            return localVarFp.setResource(tenantId, id, setResourceDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ResourcesApi - object-oriented interface
 * @export
 * @class ResourcesApi
 * @extends {BaseAPI}
 */
export class ResourcesApi extends BaseAPI {
    /**
     * 
     * @summary Delete resource by id
     * @param {string} tenantId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public deleteResource(tenantId: string, id: string, options?: AxiosRequestConfig) {
        return ResourcesApiFp(this.configuration).deleteResource(tenantId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get resource by id
     * @param {string} tenantId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public getResource(tenantId: string, id: string, options?: AxiosRequestConfig) {
        return ResourcesApiFp(this.configuration).getResource(tenantId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List resources. If `permission` parameter is specified, endpoint will require - valid token that will have `permission` from query (bindings don\'t matter).
     * @param {string} tenantId 
     * @param {string} [permission] Optional permission to filter resources based on user token
     * @param {string} [type] Resource type, a prefix in resource id, like - bu, for Business units.
     * @param {Array<string>} [additionalBindings] Additional bindings to consider when listing resources. E.g. getting all bindings for type \&quot;ccc.kind\&quot;, while filtering out ones without the access to specific \&quot;bu\&quot; resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public getResources(tenantId: string, permission?: string, type?: string, additionalBindings?: Array<string>, options?: AxiosRequestConfig) {
        return ResourcesApiFp(this.configuration).getResources(tenantId, permission, type, additionalBindings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set resource
     * @param {string} tenantId 
     * @param {string} id 
     * @param {SetResourceDto} setResourceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public setResource(tenantId: string, id: string, setResourceDto: SetResourceDto, options?: AxiosRequestConfig) {
        return ResourcesApiFp(this.configuration).setResource(tenantId, id, setResourceDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RolesApi - axios parameter creator
 * @export
 */
export const RolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create role
         * @param {CreateRoleDto} createRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole: async (createRoleDto: CreateRoleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRoleDto' is not null or undefined
            assertParamExists('createRole', 'createRoleDto', createRoleDto)
            const localVarPath = `/api/v1/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRoleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get role by id
         * @param {string} id Role id must follow the pattern: {systemPrefix}.{role} and contain a-z letters and hyphens where the systemPrefix size is 3 and role is between 2 and 30 characters.
         * @param {boolean} [returnAliases] If set to true, permissions array will contain permission aliases instead of permission ids (or id if no alias is found)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole: async (id: string, returnAliases?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRole', 'id', id)
            const localVarPath = `/api/v1/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (returnAliases !== undefined) {
                localVarQueryParameter['returnAliases'] = returnAliases;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List roles
         * @param {string} [searchString] searchString only works, when sortBy is selected and searches in &#x60;sortBy&#x60; field
         * @param {OrderByDirection} [direction] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {RoleFields} [sortBy] 
         * @param {boolean} [returnAliases] If set to true, permissions array will contain permission aliases instead of permission ids (or id if no alias is found)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles: async (searchString?: string, direction?: OrderByDirection, limit?: number, offset?: number, sortBy?: RoleFields, returnAliases?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (returnAliases !== undefined) {
                localVarQueryParameter['returnAliases'] = returnAliases;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update role by id
         * @param {string} id Role id must follow the pattern: {systemPrefix}.{role} and contain a-z letters and hyphens where the systemPrefix size is 3 and role is between 2 and 30 characters.
         * @param {UpdateRoleDto} updateRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole: async (id: string, updateRoleDto: UpdateRoleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateRole', 'id', id)
            // verify required parameter 'updateRoleDto' is not null or undefined
            assertParamExists('updateRole', 'updateRoleDto', updateRoleDto)
            const localVarPath = `/api/v1/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRoleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RolesApi - functional programming interface
 * @export
 */
export const RolesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RolesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create role
         * @param {CreateRoleDto} createRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRole(createRoleDto: CreateRoleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRole(createRoleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get role by id
         * @param {string} id Role id must follow the pattern: {systemPrefix}.{role} and contain a-z letters and hyphens where the systemPrefix size is 3 and role is between 2 and 30 characters.
         * @param {boolean} [returnAliases] If set to true, permissions array will contain permission aliases instead of permission ids (or id if no alias is found)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRole(id: string, returnAliases?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRole(id, returnAliases, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List roles
         * @param {string} [searchString] searchString only works, when sortBy is selected and searches in &#x60;sortBy&#x60; field
         * @param {OrderByDirection} [direction] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {RoleFields} [sortBy] 
         * @param {boolean} [returnAliases] If set to true, permissions array will contain permission aliases instead of permission ids (or id if no alias is found)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoles(searchString?: string, direction?: OrderByDirection, limit?: number, offset?: number, sortBy?: RoleFields, returnAliases?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoles(searchString, direction, limit, offset, sortBy, returnAliases, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update role by id
         * @param {string} id Role id must follow the pattern: {systemPrefix}.{role} and contain a-z letters and hyphens where the systemPrefix size is 3 and role is between 2 and 30 characters.
         * @param {UpdateRoleDto} updateRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRole(id: string, updateRoleDto: UpdateRoleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRole(id, updateRoleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RolesApi - factory interface
 * @export
 */
export const RolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RolesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create role
         * @param {CreateRoleDto} createRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole(createRoleDto: CreateRoleDto, options?: any): AxiosPromise<RoleDto> {
            return localVarFp.createRole(createRoleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get role by id
         * @param {string} id Role id must follow the pattern: {systemPrefix}.{role} and contain a-z letters and hyphens where the systemPrefix size is 3 and role is between 2 and 30 characters.
         * @param {boolean} [returnAliases] If set to true, permissions array will contain permission aliases instead of permission ids (or id if no alias is found)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole(id: string, returnAliases?: boolean, options?: any): AxiosPromise<RoleDto> {
            return localVarFp.getRole(id, returnAliases, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List roles
         * @param {string} [searchString] searchString only works, when sortBy is selected and searches in &#x60;sortBy&#x60; field
         * @param {OrderByDirection} [direction] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {RoleFields} [sortBy] 
         * @param {boolean} [returnAliases] If set to true, permissions array will contain permission aliases instead of permission ids (or id if no alias is found)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles(searchString?: string, direction?: OrderByDirection, limit?: number, offset?: number, sortBy?: RoleFields, returnAliases?: boolean, options?: any): AxiosPromise<Array<RoleDto>> {
            return localVarFp.getRoles(searchString, direction, limit, offset, sortBy, returnAliases, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update role by id
         * @param {string} id Role id must follow the pattern: {systemPrefix}.{role} and contain a-z letters and hyphens where the systemPrefix size is 3 and role is between 2 and 30 characters.
         * @param {UpdateRoleDto} updateRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole(id: string, updateRoleDto: UpdateRoleDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateRole(id, updateRoleDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RolesApi - object-oriented interface
 * @export
 * @class RolesApi
 * @extends {BaseAPI}
 */
export class RolesApi extends BaseAPI {
    /**
     * 
     * @summary Create role
     * @param {CreateRoleDto} createRoleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public createRole(createRoleDto: CreateRoleDto, options?: AxiosRequestConfig) {
        return RolesApiFp(this.configuration).createRole(createRoleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get role by id
     * @param {string} id Role id must follow the pattern: {systemPrefix}.{role} and contain a-z letters and hyphens where the systemPrefix size is 3 and role is between 2 and 30 characters.
     * @param {boolean} [returnAliases] If set to true, permissions array will contain permission aliases instead of permission ids (or id if no alias is found)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public getRole(id: string, returnAliases?: boolean, options?: AxiosRequestConfig) {
        return RolesApiFp(this.configuration).getRole(id, returnAliases, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List roles
     * @param {string} [searchString] searchString only works, when sortBy is selected and searches in &#x60;sortBy&#x60; field
     * @param {OrderByDirection} [direction] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {RoleFields} [sortBy] 
     * @param {boolean} [returnAliases] If set to true, permissions array will contain permission aliases instead of permission ids (or id if no alias is found)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public getRoles(searchString?: string, direction?: OrderByDirection, limit?: number, offset?: number, sortBy?: RoleFields, returnAliases?: boolean, options?: AxiosRequestConfig) {
        return RolesApiFp(this.configuration).getRoles(searchString, direction, limit, offset, sortBy, returnAliases, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update role by id
     * @param {string} id Role id must follow the pattern: {systemPrefix}.{role} and contain a-z letters and hyphens where the systemPrefix size is 3 and role is between 2 and 30 characters.
     * @param {UpdateRoleDto} updateRoleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public updateRole(id: string, updateRoleDto: UpdateRoleDto, options?: AxiosRequestConfig) {
        return RolesApiFp(this.configuration).updateRole(id, updateRoleDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SamlIdentityProvidersApi - axios parameter creator
 * @export
 */
export const SamlIdentityProvidersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create SAML Identity provider
         * @param {string} tenantId 
         * @param {CreateSamlIdentityProviderDto} createSamlIdentityProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSamlProvider: async (tenantId: string, createSamlIdentityProviderDto: CreateSamlIdentityProviderDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createSamlProvider', 'tenantId', tenantId)
            // verify required parameter 'createSamlIdentityProviderDto' is not null or undefined
            assertParamExists('createSamlProvider', 'createSamlIdentityProviderDto', createSamlIdentityProviderDto)
            const localVarPath = `/api/v1/tenants/{tenantId}/providers-saml`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSamlIdentityProviderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disable SAML Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableSamlProvider: async (id: string, tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('disableSamlProvider', 'id', id)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('disableSamlProvider', 'tenantId', tenantId)
            const localVarPath = `/api/v1/tenants/{tenantId}/providers-saml/{id}/disable`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enable SAML Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableSamlProvider: async (id: string, tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('enableSamlProvider', 'id', id)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('enableSamlProvider', 'tenantId', tenantId)
            const localVarPath = `/api/v1/tenants/{tenantId}/providers-saml/{id}/enable`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get SAML Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSamlProvider: async (id: string, tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSamlProvider', 'id', id)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getSamlProvider', 'tenantId', tenantId)
            const localVarPath = `/api/v1/tenants/{tenantId}/providers-saml/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List SAML Identity Providers
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSamlProviders: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getSamlProviders', 'tenantId', tenantId)
            const localVarPath = `/api/v1/tenants/{tenantId}/providers-saml`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update SAML Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {UpdateSamlIdentityProviderDto} updateSamlIdentityProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSamlProvider: async (id: string, tenantId: string, updateSamlIdentityProviderDto: UpdateSamlIdentityProviderDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSamlProvider', 'id', id)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateSamlProvider', 'tenantId', tenantId)
            // verify required parameter 'updateSamlIdentityProviderDto' is not null or undefined
            assertParamExists('updateSamlProvider', 'updateSamlIdentityProviderDto', updateSamlIdentityProviderDto)
            const localVarPath = `/api/v1/tenants/{tenantId}/providers-saml/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSamlIdentityProviderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SamlIdentityProvidersApi - functional programming interface
 * @export
 */
export const SamlIdentityProvidersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SamlIdentityProvidersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create SAML Identity provider
         * @param {string} tenantId 
         * @param {CreateSamlIdentityProviderDto} createSamlIdentityProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSamlProvider(tenantId: string, createSamlIdentityProviderDto: CreateSamlIdentityProviderDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateSamlIdentityProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSamlProvider(tenantId, createSamlIdentityProviderDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Disable SAML Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableSamlProvider(id: string, tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableSamlProvider(id, tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Enable SAML Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableSamlProvider(id: string, tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableSamlProvider(id, tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get SAML Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSamlProvider(id: string, tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SamlIdentityProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSamlProvider(id, tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List SAML Identity Providers
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSamlProviders(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SamlIdentityProviderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSamlProviders(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update SAML Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {UpdateSamlIdentityProviderDto} updateSamlIdentityProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSamlProvider(id: string, tenantId: string, updateSamlIdentityProviderDto: UpdateSamlIdentityProviderDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSamlProvider(id, tenantId, updateSamlIdentityProviderDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SamlIdentityProvidersApi - factory interface
 * @export
 */
export const SamlIdentityProvidersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SamlIdentityProvidersApiFp(configuration)
    return {
        /**
         * 
         * @summary Create SAML Identity provider
         * @param {string} tenantId 
         * @param {CreateSamlIdentityProviderDto} createSamlIdentityProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSamlProvider(tenantId: string, createSamlIdentityProviderDto: CreateSamlIdentityProviderDto, options?: any): AxiosPromise<CreateSamlIdentityProviderDto> {
            return localVarFp.createSamlProvider(tenantId, createSamlIdentityProviderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disable SAML Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableSamlProvider(id: string, tenantId: string, options?: any): AxiosPromise<void> {
            return localVarFp.disableSamlProvider(id, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enable SAML Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableSamlProvider(id: string, tenantId: string, options?: any): AxiosPromise<void> {
            return localVarFp.enableSamlProvider(id, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get SAML Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSamlProvider(id: string, tenantId: string, options?: any): AxiosPromise<SamlIdentityProviderDto> {
            return localVarFp.getSamlProvider(id, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List SAML Identity Providers
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSamlProviders(tenantId: string, options?: any): AxiosPromise<Array<SamlIdentityProviderDto>> {
            return localVarFp.getSamlProviders(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update SAML Identity Provider by id
         * @param {string} id 
         * @param {string} tenantId 
         * @param {UpdateSamlIdentityProviderDto} updateSamlIdentityProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSamlProvider(id: string, tenantId: string, updateSamlIdentityProviderDto: UpdateSamlIdentityProviderDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateSamlProvider(id, tenantId, updateSamlIdentityProviderDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SamlIdentityProvidersApi - object-oriented interface
 * @export
 * @class SamlIdentityProvidersApi
 * @extends {BaseAPI}
 */
export class SamlIdentityProvidersApi extends BaseAPI {
    /**
     * 
     * @summary Create SAML Identity provider
     * @param {string} tenantId 
     * @param {CreateSamlIdentityProviderDto} createSamlIdentityProviderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SamlIdentityProvidersApi
     */
    public createSamlProvider(tenantId: string, createSamlIdentityProviderDto: CreateSamlIdentityProviderDto, options?: AxiosRequestConfig) {
        return SamlIdentityProvidersApiFp(this.configuration).createSamlProvider(tenantId, createSamlIdentityProviderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disable SAML Identity Provider by id
     * @param {string} id 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SamlIdentityProvidersApi
     */
    public disableSamlProvider(id: string, tenantId: string, options?: AxiosRequestConfig) {
        return SamlIdentityProvidersApiFp(this.configuration).disableSamlProvider(id, tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enable SAML Identity Provider by id
     * @param {string} id 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SamlIdentityProvidersApi
     */
    public enableSamlProvider(id: string, tenantId: string, options?: AxiosRequestConfig) {
        return SamlIdentityProvidersApiFp(this.configuration).enableSamlProvider(id, tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get SAML Identity Provider by id
     * @param {string} id 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SamlIdentityProvidersApi
     */
    public getSamlProvider(id: string, tenantId: string, options?: AxiosRequestConfig) {
        return SamlIdentityProvidersApiFp(this.configuration).getSamlProvider(id, tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List SAML Identity Providers
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SamlIdentityProvidersApi
     */
    public getSamlProviders(tenantId: string, options?: AxiosRequestConfig) {
        return SamlIdentityProvidersApiFp(this.configuration).getSamlProviders(tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update SAML Identity Provider by id
     * @param {string} id 
     * @param {string} tenantId 
     * @param {UpdateSamlIdentityProviderDto} updateSamlIdentityProviderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SamlIdentityProvidersApi
     */
    public updateSamlProvider(id: string, tenantId: string, updateSamlIdentityProviderDto: UpdateSamlIdentityProviderDto, options?: AxiosRequestConfig) {
        return SamlIdentityProvidersApiFp(this.configuration).updateSamlProvider(id, tenantId, updateSamlIdentityProviderDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SupportCaseApi - axios parameter creator
 * @export
 */
export const SupportCaseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Accept support case (tenant should accept the case)
         * @summary Accept support case
         * @param {string} supportCaseId The support case id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptCase: async (supportCaseId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supportCaseId' is not null or undefined
            assertParamExists('acceptCase', 'supportCaseId', supportCaseId)
            const localVarPath = `/api/v1/support-cases/{supportCaseId}/accept`
                .replace(`{${"supportCaseId"}}`, encodeURIComponent(String(supportCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel support case (can be done be either tenant or support)
         * @summary Cancel support case
         * @param {string} supportCaseId The support case id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeCase: async (supportCaseId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supportCaseId' is not null or undefined
            assertParamExists('closeCase', 'supportCaseId', supportCaseId)
            const localVarPath = `/api/v1/support-cases/{supportCaseId}/close`
                .replace(`{${"supportCaseId"}}`, encodeURIComponent(String(supportCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create support case
         * @summary Create support case
         * @param {CreateSupportCaseBody} createSupportCaseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCase: async (createSupportCaseBody: CreateSupportCaseBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSupportCaseBody' is not null or undefined
            assertParamExists('createCase', 'createSupportCaseBody', createSupportCaseBody)
            const localVarPath = `/api/v1/support-cases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSupportCaseBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create credentials for assignee to access the case
         * @summary Create credentials for assignee to access the case
         * @param {string} supportCaseId The support case id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCredentials: async (supportCaseId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supportCaseId' is not null or undefined
            assertParamExists('createCredentials', 'supportCaseId', supportCaseId)
            const localVarPath = `/api/v1/support-cases/{supportCaseId}/credentials`
                .replace(`{${"supportCaseId"}}`, encodeURIComponent(String(supportCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get support cases
         * @summary Get support cases by status, tenant id or user profile id
         * @param {number} take 
         * @param {number} skip 
         * @param {SupportCaseStatus} [status] The status of the support case
         * @param {string} [tenantId] The tenant id
         * @param {string} [userProfileId] The user profile id, to filter cases created by the user or assignees
         * @param {string} [createdAfter] Support cases older than this will not be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCases: async (take: number, skip: number, status?: SupportCaseStatus, tenantId?: string, userProfileId?: string, createdAfter?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'take' is not null or undefined
            assertParamExists('findCases', 'take', take)
            // verify required parameter 'skip' is not null or undefined
            assertParamExists('findCases', 'skip', skip)
            const localVarPath = `/api/v1/support-cases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }

            if (userProfileId !== undefined) {
                localVarQueryParameter['userProfileId'] = userProfileId;
            }

            if (createdAfter !== undefined) {
                localVarQueryParameter['createdAfter'] = (createdAfter as any instanceof Date) ?
                    (createdAfter as any).toISOString() :
                    createdAfter;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get audit logs by support case id
         * @summary Get audit logs by support case id
         * @param {string} supportCaseId The support case id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditLogsByCase: async (supportCaseId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supportCaseId' is not null or undefined
            assertParamExists('getAuditLogsByCase', 'supportCaseId', supportCaseId)
            const localVarPath = `/api/v1/support-cases/{supportCaseId}/audit-logs`
                .replace(`{${"supportCaseId"}}`, encodeURIComponent(String(supportCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get support case
         * @summary Get support cases by id
         * @param {string} supportCaseId The support case id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCase: async (supportCaseId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supportCaseId' is not null or undefined
            assertParamExists('getCase', 'supportCaseId', supportCaseId)
            const localVarPath = `/api/v1/support-cases/{supportCaseId}`
                .replace(`{${"supportCaseId"}}`, encodeURIComponent(String(supportCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reject support case (tenant should reject the case)
         * @summary Reject support case
         * @param {string} supportCaseId The support case id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectCase: async (supportCaseId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supportCaseId' is not null or undefined
            assertParamExists('rejectCase', 'supportCaseId', supportCaseId)
            const localVarPath = `/api/v1/support-cases/{supportCaseId}/reject`
                .replace(`{${"supportCaseId"}}`, encodeURIComponent(String(supportCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupportCaseApi - functional programming interface
 * @export
 */
export const SupportCaseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupportCaseApiAxiosParamCreator(configuration)
    return {
        /**
         * Accept support case (tenant should accept the case)
         * @summary Accept support case
         * @param {string} supportCaseId The support case id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptCase(supportCaseId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptCase(supportCaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Cancel support case (can be done be either tenant or support)
         * @summary Cancel support case
         * @param {string} supportCaseId The support case id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeCase(supportCaseId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeCase(supportCaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create support case
         * @summary Create support case
         * @param {CreateSupportCaseBody} createSupportCaseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCase(createSupportCaseBody: CreateSupportCaseBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupportCaseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCase(createSupportCaseBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create credentials for assignee to access the case
         * @summary Create credentials for assignee to access the case
         * @param {string} supportCaseId The support case id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCredentials(supportCaseId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupportCaseCredentialsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCredentials(supportCaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get support cases
         * @summary Get support cases by status, tenant id or user profile id
         * @param {number} take 
         * @param {number} skip 
         * @param {SupportCaseStatus} [status] The status of the support case
         * @param {string} [tenantId] The tenant id
         * @param {string} [userProfileId] The user profile id, to filter cases created by the user or assignees
         * @param {string} [createdAfter] Support cases older than this will not be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findCases(take: number, skip: number, status?: SupportCaseStatus, tenantId?: string, userProfileId?: string, createdAfter?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SupportCaseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findCases(take, skip, status, tenantId, userProfileId, createdAfter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get audit logs by support case id
         * @summary Get audit logs by support case id
         * @param {string} supportCaseId The support case id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuditLogsByCase(supportCaseId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SupportCaseAuditLogDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuditLogsByCase(supportCaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get support case
         * @summary Get support cases by id
         * @param {string} supportCaseId The support case id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCase(supportCaseId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupportCaseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCase(supportCaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Reject support case (tenant should reject the case)
         * @summary Reject support case
         * @param {string} supportCaseId The support case id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectCase(supportCaseId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectCase(supportCaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SupportCaseApi - factory interface
 * @export
 */
export const SupportCaseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupportCaseApiFp(configuration)
    return {
        /**
         * Accept support case (tenant should accept the case)
         * @summary Accept support case
         * @param {string} supportCaseId The support case id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptCase(supportCaseId: string, options?: any): AxiosPromise<void> {
            return localVarFp.acceptCase(supportCaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel support case (can be done be either tenant or support)
         * @summary Cancel support case
         * @param {string} supportCaseId The support case id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeCase(supportCaseId: string, options?: any): AxiosPromise<void> {
            return localVarFp.closeCase(supportCaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create support case
         * @summary Create support case
         * @param {CreateSupportCaseBody} createSupportCaseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCase(createSupportCaseBody: CreateSupportCaseBody, options?: any): AxiosPromise<SupportCaseDto> {
            return localVarFp.createCase(createSupportCaseBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Create credentials for assignee to access the case
         * @summary Create credentials for assignee to access the case
         * @param {string} supportCaseId The support case id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCredentials(supportCaseId: string, options?: any): AxiosPromise<SupportCaseCredentialsDto> {
            return localVarFp.createCredentials(supportCaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get support cases
         * @summary Get support cases by status, tenant id or user profile id
         * @param {number} take 
         * @param {number} skip 
         * @param {SupportCaseStatus} [status] The status of the support case
         * @param {string} [tenantId] The tenant id
         * @param {string} [userProfileId] The user profile id, to filter cases created by the user or assignees
         * @param {string} [createdAfter] Support cases older than this will not be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCases(take: number, skip: number, status?: SupportCaseStatus, tenantId?: string, userProfileId?: string, createdAfter?: string, options?: any): AxiosPromise<Array<SupportCaseDto>> {
            return localVarFp.findCases(take, skip, status, tenantId, userProfileId, createdAfter, options).then((request) => request(axios, basePath));
        },
        /**
         * Get audit logs by support case id
         * @summary Get audit logs by support case id
         * @param {string} supportCaseId The support case id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditLogsByCase(supportCaseId: string, options?: any): AxiosPromise<Array<SupportCaseAuditLogDto>> {
            return localVarFp.getAuditLogsByCase(supportCaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get support case
         * @summary Get support cases by id
         * @param {string} supportCaseId The support case id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCase(supportCaseId: string, options?: any): AxiosPromise<SupportCaseDto> {
            return localVarFp.getCase(supportCaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Reject support case (tenant should reject the case)
         * @summary Reject support case
         * @param {string} supportCaseId The support case id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectCase(supportCaseId: string, options?: any): AxiosPromise<void> {
            return localVarFp.rejectCase(supportCaseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupportCaseApi - object-oriented interface
 * @export
 * @class SupportCaseApi
 * @extends {BaseAPI}
 */
export class SupportCaseApi extends BaseAPI {
    /**
     * Accept support case (tenant should accept the case)
     * @summary Accept support case
     * @param {string} supportCaseId The support case id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportCaseApi
     */
    public acceptCase(supportCaseId: string, options?: AxiosRequestConfig) {
        return SupportCaseApiFp(this.configuration).acceptCase(supportCaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel support case (can be done be either tenant or support)
     * @summary Cancel support case
     * @param {string} supportCaseId The support case id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportCaseApi
     */
    public closeCase(supportCaseId: string, options?: AxiosRequestConfig) {
        return SupportCaseApiFp(this.configuration).closeCase(supportCaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create support case
     * @summary Create support case
     * @param {CreateSupportCaseBody} createSupportCaseBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportCaseApi
     */
    public createCase(createSupportCaseBody: CreateSupportCaseBody, options?: AxiosRequestConfig) {
        return SupportCaseApiFp(this.configuration).createCase(createSupportCaseBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create credentials for assignee to access the case
     * @summary Create credentials for assignee to access the case
     * @param {string} supportCaseId The support case id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportCaseApi
     */
    public createCredentials(supportCaseId: string, options?: AxiosRequestConfig) {
        return SupportCaseApiFp(this.configuration).createCredentials(supportCaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get support cases
     * @summary Get support cases by status, tenant id or user profile id
     * @param {number} take 
     * @param {number} skip 
     * @param {SupportCaseStatus} [status] The status of the support case
     * @param {string} [tenantId] The tenant id
     * @param {string} [userProfileId] The user profile id, to filter cases created by the user or assignees
     * @param {string} [createdAfter] Support cases older than this will not be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportCaseApi
     */
    public findCases(take: number, skip: number, status?: SupportCaseStatus, tenantId?: string, userProfileId?: string, createdAfter?: string, options?: AxiosRequestConfig) {
        return SupportCaseApiFp(this.configuration).findCases(take, skip, status, tenantId, userProfileId, createdAfter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get audit logs by support case id
     * @summary Get audit logs by support case id
     * @param {string} supportCaseId The support case id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportCaseApi
     */
    public getAuditLogsByCase(supportCaseId: string, options?: AxiosRequestConfig) {
        return SupportCaseApiFp(this.configuration).getAuditLogsByCase(supportCaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get support case
     * @summary Get support cases by id
     * @param {string} supportCaseId The support case id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportCaseApi
     */
    public getCase(supportCaseId: string, options?: AxiosRequestConfig) {
        return SupportCaseApiFp(this.configuration).getCase(supportCaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reject support case (tenant should reject the case)
     * @summary Reject support case
     * @param {string} supportCaseId The support case id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportCaseApi
     */
    public rejectCase(supportCaseId: string, options?: AxiosRequestConfig) {
        return SupportCaseApiFp(this.configuration).rejectCase(supportCaseId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TenantsApi - axios parameter creator
 * @export
 */
export const TenantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create tenant
         * @param {CreateTenantDto} createTenantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenant: async (createTenantDto: CreateTenantDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTenantDto' is not null or undefined
            assertParamExists('createTenant', 'createTenantDto', createTenantDto)
            const localVarPath = `/api/v1/tenants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTenantDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create test tenant
         * @param {string} tenantId 
         * @param {CreateTestTenantDto} createTestTenantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestTenant: async (tenantId: string, createTestTenantDto: CreateTestTenantDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createTestTenant', 'tenantId', tenantId)
            // verify required parameter 'createTestTenantDto' is not null or undefined
            assertParamExists('createTestTenant', 'createTestTenantDto', createTestTenantDto)
            const localVarPath = `/api/v1/tenants/{tenantId}/test-tenant`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTestTenantDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get tenant by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenant: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTenant', 'id', id)
            const localVarPath = `/api/v1/tenants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List tenants
         * @param {number} skip Skip certain number of records
         * @param {number} take Take certain number of records
         * @param {string} [alias] Tenant alias. Used as CNAME for tenant, for example tenant with alias extenda is accessable at https://extenda.hiiretail.com
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenants: async (skip: number, take: number, alias?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skip' is not null or undefined
            assertParamExists('getTenants', 'skip', skip)
            // verify required parameter 'take' is not null or undefined
            assertParamExists('getTenants', 'take', take)
            const localVarPath = `/api/v1/tenants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (alias !== undefined) {
                localVarQueryParameter['alias'] = alias;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update tenant by id
         * @param {string} id 
         * @param {UpdateTenantDto} updateTenantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenant: async (id: string, updateTenantDto: UpdateTenantDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTenant', 'id', id)
            // verify required parameter 'updateTenantDto' is not null or undefined
            assertParamExists('updateTenant', 'updateTenantDto', updateTenantDto)
            const localVarPath = `/api/v1/tenants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTenantDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantsApi - functional programming interface
 * @export
 */
export const TenantsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create tenant
         * @param {CreateTenantDto} createTenantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTenant(createTenantDto: CreateTenantDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTenant(createTenantDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create test tenant
         * @param {string} tenantId 
         * @param {CreateTestTenantDto} createTestTenantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTestTenant(tenantId: string, createTestTenantDto: CreateTestTenantDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTestTenant(tenantId, createTestTenantDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get tenant by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTenant(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTenant(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List tenants
         * @param {number} skip Skip certain number of records
         * @param {number} take Take certain number of records
         * @param {string} [alias] Tenant alias. Used as CNAME for tenant, for example tenant with alias extenda is accessable at https://extenda.hiiretail.com
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTenants(skip: number, take: number, alias?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTenants(skip, take, alias, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update tenant by id
         * @param {string} id 
         * @param {UpdateTenantDto} updateTenantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTenant(id: string, updateTenantDto: UpdateTenantDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTenant(id, updateTenantDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TenantsApi - factory interface
 * @export
 */
export const TenantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create tenant
         * @param {CreateTenantDto} createTenantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenant(createTenantDto: CreateTenantDto, options?: any): AxiosPromise<TenantDto> {
            return localVarFp.createTenant(createTenantDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create test tenant
         * @param {string} tenantId 
         * @param {CreateTestTenantDto} createTestTenantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestTenant(tenantId: string, createTestTenantDto: CreateTestTenantDto, options?: any): AxiosPromise<TenantDto> {
            return localVarFp.createTestTenant(tenantId, createTestTenantDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get tenant by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenant(id: string, options?: any): AxiosPromise<TenantDto> {
            return localVarFp.getTenant(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List tenants
         * @param {number} skip Skip certain number of records
         * @param {number} take Take certain number of records
         * @param {string} [alias] Tenant alias. Used as CNAME for tenant, for example tenant with alias extenda is accessable at https://extenda.hiiretail.com
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenants(skip: number, take: number, alias?: string, options?: any): AxiosPromise<Array<TenantDto>> {
            return localVarFp.getTenants(skip, take, alias, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update tenant by id
         * @param {string} id 
         * @param {UpdateTenantDto} updateTenantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenant(id: string, updateTenantDto: UpdateTenantDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateTenant(id, updateTenantDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TenantsApi - object-oriented interface
 * @export
 * @class TenantsApi
 * @extends {BaseAPI}
 */
export class TenantsApi extends BaseAPI {
    /**
     * 
     * @summary Create tenant
     * @param {CreateTenantDto} createTenantDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public createTenant(createTenantDto: CreateTenantDto, options?: AxiosRequestConfig) {
        return TenantsApiFp(this.configuration).createTenant(createTenantDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create test tenant
     * @param {string} tenantId 
     * @param {CreateTestTenantDto} createTestTenantDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public createTestTenant(tenantId: string, createTestTenantDto: CreateTestTenantDto, options?: AxiosRequestConfig) {
        return TenantsApiFp(this.configuration).createTestTenant(tenantId, createTestTenantDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get tenant by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public getTenant(id: string, options?: AxiosRequestConfig) {
        return TenantsApiFp(this.configuration).getTenant(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List tenants
     * @param {number} skip Skip certain number of records
     * @param {number} take Take certain number of records
     * @param {string} [alias] Tenant alias. Used as CNAME for tenant, for example tenant with alias extenda is accessable at https://extenda.hiiretail.com
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public getTenants(skip: number, take: number, alias?: string, options?: AxiosRequestConfig) {
        return TenantsApiFp(this.configuration).getTenants(skip, take, alias, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update tenant by id
     * @param {string} id 
     * @param {UpdateTenantDto} updateTenantDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public updateTenant(id: string, updateTenantDto: UpdateTenantDto, options?: AxiosRequestConfig) {
        return TenantsApiFp(this.configuration).updateTenant(id, updateTenantDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserProfileApi - axios parameter creator
 * @export
 */
export const UserProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  User profile requires valid IAM token (all other tokens will be rejected), with the same tenantId, that in path and does not require any specific permissions. Behavior of an endpoint depends on token. 
         * @summary Get all permissions for a passed User token
         * @param {string} tenantId 
         * @param {boolean} [fullPermission] 
         * @param {string} [resourceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnPermissions: async (tenantId: string, fullPermission?: boolean, resourceId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getOwnPermissions', 'tenantId', tenantId)
            const localVarPath = `/api/v1/tenants/{tenantId}/user-profile/permissions`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fullPermission !== undefined) {
                localVarQueryParameter['fullPermission'] = fullPermission;
            }

            if (resourceId !== undefined) {
                localVarQueryParameter['resourceId'] = resourceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  User profile requires valid IAM token (all other tokens will be rejected), with the same tenantId, that in path and does not require any specific permissions. Behavior of an endpoint depends on token. 
         * @summary Get own profile
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProfile: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getUserProfile', 'tenantId', tenantId)
            const localVarPath = `/api/v1/tenants/{tenantId}/user-profile`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *        Redirects to IDP logout endpoit if one was configured.       If no logout url is configured, \'fallbackRedirectUrl\' query param is used.
         * @summary Redirects to IDP logout endpoit if one was configured. Endpoint is publicly available, it only interacts with current user session
         * @param {string} tenantId 
         * @param {string} fallbackRedirectUrl        Fallback url for redirect if federated identity provider logout url is not found.     
         * @param {string} idProviderConnectionId Provider Connection ID in IAM API
         * @param {string} [externalUserId] User id from extrnal identity provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (tenantId: string, fallbackRedirectUrl: string, idProviderConnectionId: string, externalUserId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('logout', 'tenantId', tenantId)
            // verify required parameter 'fallbackRedirectUrl' is not null or undefined
            assertParamExists('logout', 'fallbackRedirectUrl', fallbackRedirectUrl)
            // verify required parameter 'idProviderConnectionId' is not null or undefined
            assertParamExists('logout', 'idProviderConnectionId', idProviderConnectionId)
            const localVarPath = `/api/v1/tenants/{tenantId}/user-profile/logout`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fallbackRedirectUrl !== undefined) {
                localVarQueryParameter['fallbackRedirectUrl'] = fallbackRedirectUrl;
            }

            if (idProviderConnectionId !== undefined) {
                localVarQueryParameter['idProviderConnectionId'] = idProviderConnectionId;
            }

            if (externalUserId !== undefined) {
                localVarQueryParameter['externalUserId'] = externalUserId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  User profile requires valid IAM token (all other tokens will be rejected), with the same tenantId, that in path and does not require any specific permissions. Behavior of an endpoint depends on token. 
         * @summary Reset own password
         * @param {string} tenantId 
         * @param {ResetPasswordDto} resetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetOwnPassword: async (tenantId: string, resetPasswordDto: ResetPasswordDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('resetOwnPassword', 'tenantId', tenantId)
            // verify required parameter 'resetPasswordDto' is not null or undefined
            assertParamExists('resetOwnPassword', 'resetPasswordDto', resetPasswordDto)
            const localVarPath = `/api/v1/tenants/{tenantId}/user-profile/password`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  User profile requires valid IAM token (all other tokens will be rejected), with the same tenantId, that in path and does not require any specific permissions. Behavior of an endpoint depends on token. 
         * @summary Update own profile
         * @param {string} tenantId 
         * @param {UpdateUserProfileDto} updateUserProfileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserProfile: async (tenantId: string, updateUserProfileDto: UpdateUserProfileDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateUserProfile', 'tenantId', tenantId)
            // verify required parameter 'updateUserProfileDto' is not null or undefined
            assertParamExists('updateUserProfile', 'updateUserProfileDto', updateUserProfileDto)
            const localVarPath = `/api/v1/tenants/{tenantId}/user-profile`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserProfileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserProfileApi - functional programming interface
 * @export
 */
export const UserProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserProfileApiAxiosParamCreator(configuration)
    return {
        /**
         *  User profile requires valid IAM token (all other tokens will be rejected), with the same tenantId, that in path and does not require any specific permissions. Behavior of an endpoint depends on token. 
         * @summary Get all permissions for a passed User token
         * @param {string} tenantId 
         * @param {boolean} [fullPermission] 
         * @param {string} [resourceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOwnPermissions(tenantId: string, fullPermission?: boolean, resourceId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PermissionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOwnPermissions(tenantId, fullPermission, resourceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  User profile requires valid IAM token (all other tokens will be rejected), with the same tenantId, that in path and does not require any specific permissions. Behavior of an endpoint depends on token. 
         * @summary Get own profile
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserProfile(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserProfile(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *        Redirects to IDP logout endpoit if one was configured.       If no logout url is configured, \'fallbackRedirectUrl\' query param is used.
         * @summary Redirects to IDP logout endpoit if one was configured. Endpoint is publicly available, it only interacts with current user session
         * @param {string} tenantId 
         * @param {string} fallbackRedirectUrl        Fallback url for redirect if federated identity provider logout url is not found.     
         * @param {string} idProviderConnectionId Provider Connection ID in IAM API
         * @param {string} [externalUserId] User id from extrnal identity provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(tenantId: string, fallbackRedirectUrl: string, idProviderConnectionId: string, externalUserId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(tenantId, fallbackRedirectUrl, idProviderConnectionId, externalUserId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  User profile requires valid IAM token (all other tokens will be rejected), with the same tenantId, that in path and does not require any specific permissions. Behavior of an endpoint depends on token. 
         * @summary Reset own password
         * @param {string} tenantId 
         * @param {ResetPasswordDto} resetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetOwnPassword(tenantId: string, resetPasswordDto: ResetPasswordDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetOwnPassword(tenantId, resetPasswordDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  User profile requires valid IAM token (all other tokens will be rejected), with the same tenantId, that in path and does not require any specific permissions. Behavior of an endpoint depends on token. 
         * @summary Update own profile
         * @param {string} tenantId 
         * @param {UpdateUserProfileDto} updateUserProfileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserProfile(tenantId: string, updateUserProfileDto: UpdateUserProfileDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserProfile(tenantId, updateUserProfileDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserProfileApi - factory interface
 * @export
 */
export const UserProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserProfileApiFp(configuration)
    return {
        /**
         *  User profile requires valid IAM token (all other tokens will be rejected), with the same tenantId, that in path and does not require any specific permissions. Behavior of an endpoint depends on token. 
         * @summary Get all permissions for a passed User token
         * @param {string} tenantId 
         * @param {boolean} [fullPermission] 
         * @param {string} [resourceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnPermissions(tenantId: string, fullPermission?: boolean, resourceId?: string, options?: any): AxiosPromise<Array<PermissionDto>> {
            return localVarFp.getOwnPermissions(tenantId, fullPermission, resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         *  User profile requires valid IAM token (all other tokens will be rejected), with the same tenantId, that in path and does not require any specific permissions. Behavior of an endpoint depends on token. 
         * @summary Get own profile
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProfile(tenantId: string, options?: any): AxiosPromise<UserDto> {
            return localVarFp.getUserProfile(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         *        Redirects to IDP logout endpoit if one was configured.       If no logout url is configured, \'fallbackRedirectUrl\' query param is used.
         * @summary Redirects to IDP logout endpoit if one was configured. Endpoint is publicly available, it only interacts with current user session
         * @param {string} tenantId 
         * @param {string} fallbackRedirectUrl        Fallback url for redirect if federated identity provider logout url is not found.     
         * @param {string} idProviderConnectionId Provider Connection ID in IAM API
         * @param {string} [externalUserId] User id from extrnal identity provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(tenantId: string, fallbackRedirectUrl: string, idProviderConnectionId: string, externalUserId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.logout(tenantId, fallbackRedirectUrl, idProviderConnectionId, externalUserId, options).then((request) => request(axios, basePath));
        },
        /**
         *  User profile requires valid IAM token (all other tokens will be rejected), with the same tenantId, that in path and does not require any specific permissions. Behavior of an endpoint depends on token. 
         * @summary Reset own password
         * @param {string} tenantId 
         * @param {ResetPasswordDto} resetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetOwnPassword(tenantId: string, resetPasswordDto: ResetPasswordDto, options?: any): AxiosPromise<void> {
            return localVarFp.resetOwnPassword(tenantId, resetPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         *  User profile requires valid IAM token (all other tokens will be rejected), with the same tenantId, that in path and does not require any specific permissions. Behavior of an endpoint depends on token. 
         * @summary Update own profile
         * @param {string} tenantId 
         * @param {UpdateUserProfileDto} updateUserProfileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserProfile(tenantId: string, updateUserProfileDto: UpdateUserProfileDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateUserProfile(tenantId, updateUserProfileDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserProfileApi - object-oriented interface
 * @export
 * @class UserProfileApi
 * @extends {BaseAPI}
 */
export class UserProfileApi extends BaseAPI {
    /**
     *  User profile requires valid IAM token (all other tokens will be rejected), with the same tenantId, that in path and does not require any specific permissions. Behavior of an endpoint depends on token. 
     * @summary Get all permissions for a passed User token
     * @param {string} tenantId 
     * @param {boolean} [fullPermission] 
     * @param {string} [resourceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public getOwnPermissions(tenantId: string, fullPermission?: boolean, resourceId?: string, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).getOwnPermissions(tenantId, fullPermission, resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  User profile requires valid IAM token (all other tokens will be rejected), with the same tenantId, that in path and does not require any specific permissions. Behavior of an endpoint depends on token. 
     * @summary Get own profile
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public getUserProfile(tenantId: string, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).getUserProfile(tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *        Redirects to IDP logout endpoit if one was configured.       If no logout url is configured, \'fallbackRedirectUrl\' query param is used.
     * @summary Redirects to IDP logout endpoit if one was configured. Endpoint is publicly available, it only interacts with current user session
     * @param {string} tenantId 
     * @param {string} fallbackRedirectUrl        Fallback url for redirect if federated identity provider logout url is not found.     
     * @param {string} idProviderConnectionId Provider Connection ID in IAM API
     * @param {string} [externalUserId] User id from extrnal identity provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public logout(tenantId: string, fallbackRedirectUrl: string, idProviderConnectionId: string, externalUserId?: string, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).logout(tenantId, fallbackRedirectUrl, idProviderConnectionId, externalUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  User profile requires valid IAM token (all other tokens will be rejected), with the same tenantId, that in path and does not require any specific permissions. Behavior of an endpoint depends on token. 
     * @summary Reset own password
     * @param {string} tenantId 
     * @param {ResetPasswordDto} resetPasswordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public resetOwnPassword(tenantId: string, resetPasswordDto: ResetPasswordDto, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).resetOwnPassword(tenantId, resetPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  User profile requires valid IAM token (all other tokens will be rejected), with the same tenantId, that in path and does not require any specific permissions. Behavior of an endpoint depends on token. 
     * @summary Update own profile
     * @param {string} tenantId 
     * @param {UpdateUserProfileDto} updateUserProfileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public updateUserProfile(tenantId: string, updateUserProfileDto: UpdateUserProfileDto, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).updateUserProfile(tenantId, updateUserProfileDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a user
         * @param {string} tenantId 
         * @param {CreateUserDto} createUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (tenantId: string, createUserDto: CreateUserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createUser', 'tenantId', tenantId)
            // verify required parameter 'createUserDto' is not null or undefined
            assertParamExists('createUser', 'createUserDto', createUserDto)
            const localVarPath = `/api/v1/tenants/{tenantId}/users`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Adds user to a group
         * @param {string} tenantId 
         * @param {string} userId 
         * @param {CreateGroupLinkDto} createGroupLinkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserGroupLink: async (tenantId: string, userId: string, createGroupLinkDto: CreateGroupLinkDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createUserGroupLink', 'tenantId', tenantId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createUserGroupLink', 'userId', userId)
            // verify required parameter 'createGroupLinkDto' is not null or undefined
            assertParamExists('createUserGroupLink', 'createGroupLinkDto', createGroupLinkDto)
            const localVarPath = `/api/v1/tenants/{tenantId}/users/{userId}/groups`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGroupLinkDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Removes user from a group
         * @param {string} tenantId 
         * @param {string} userId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserGroupLink: async (tenantId: string, userId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('deleteUserGroupLink', 'tenantId', tenantId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUserGroupLink', 'userId', userId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteUserGroupLink', 'id', id)
            const localVarPath = `/api/v1/tenants/{tenantId}/users/{userId}/groups/{id}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Finds a single user by search query. If more than one user was found 409 is returned.
         * @summary Find user
         * @param {string} tenantId 
         * @param {string} [name] User name to search for
         * @param {string} [userProfileId] Id of user profile to search for
         * @param {string} [email] User email to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUser: async (tenantId: string, name?: string, userProfileId?: string, email?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('findUser', 'tenantId', tenantId)
            const localVarPath = `/api/v1/tenants/{tenantId}/users:find`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (userProfileId !== undefined) {
                localVarQueryParameter['userProfileId'] = userProfileId;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user by id
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: async (tenantId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getUser', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUser', 'id', id)
            const localVarPath = `/api/v1/tenants/{tenantId}/users/{id}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets user group link by id
         * @param {string} tenantId 
         * @param {string} userId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupLink: async (tenantId: string, userId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getUserGroupLink', 'tenantId', tenantId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserGroupLink', 'userId', userId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUserGroupLink', 'id', id)
            const localVarPath = `/api/v1/tenants/{tenantId}/users/{userId}/groups/{id}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lists all user group links
         * @param {string} tenantId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupLinks: async (tenantId: string, userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getUserGroupLinks', 'tenantId', tenantId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserGroupLinks', 'userId', userId)
            const localVarPath = `/api/v1/tenants/{tenantId}/users/{userId}/groups`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List users
         * @param {string} tenantId 
         * @param {string} [googleUserId] 
         * @param {string} [externalId] 
         * @param {boolean} [includePii] If enabled, response will include email &amp; name. Сan be set only if googleUserId or externalId filter defined
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers: async (tenantId: string, googleUserId?: string, externalId?: string, includePii?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('listUsers', 'tenantId', tenantId)
            const localVarPath = `/api/v1/tenants/{tenantId}/users`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (googleUserId !== undefined) {
                localVarQueryParameter['googleUserId'] = googleUserId;
            }

            if (externalId !== undefined) {
                localVarQueryParameter['externalId'] = externalId;
            }

            if (includePii !== undefined) {
                localVarQueryParameter['includePii'] = includePii;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a user
         * @param {string} tenantId 
         * @param {CreateUserDto} createUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(tenantId: string, createUserDto: CreateUserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(tenantId, createUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Adds user to a group
         * @param {string} tenantId 
         * @param {string} userId 
         * @param {CreateGroupLinkDto} createGroupLinkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserGroupLink(tenantId: string, userId: string, createGroupLinkDto: CreateGroupLinkDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupLinkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserGroupLink(tenantId, userId, createGroupLinkDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Removes user from a group
         * @param {string} tenantId 
         * @param {string} userId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserGroupLink(tenantId: string, userId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserGroupLink(tenantId, userId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Finds a single user by search query. If more than one user was found 409 is returned.
         * @summary Find user
         * @param {string} tenantId 
         * @param {string} [name] User name to search for
         * @param {string} [userProfileId] Id of user profile to search for
         * @param {string} [email] User email to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findUser(tenantId: string, name?: string, userProfileId?: string, email?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findUser(tenantId, name, userProfileId, email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user by id
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUser(tenantId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUser(tenantId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets user group link by id
         * @param {string} tenantId 
         * @param {string} userId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserGroupLink(tenantId: string, userId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupLinkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserGroupLink(tenantId, userId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Lists all user group links
         * @param {string} tenantId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserGroupLinks(tenantId: string, userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupLinkDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserGroupLinks(tenantId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List users
         * @param {string} tenantId 
         * @param {string} [googleUserId] 
         * @param {string} [externalId] 
         * @param {boolean} [includePii] If enabled, response will include email &amp; name. Сan be set only if googleUserId or externalId filter defined
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUsers(tenantId: string, googleUserId?: string, externalId?: string, includePii?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsers(tenantId, googleUserId, externalId, includePii, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a user
         * @param {string} tenantId 
         * @param {CreateUserDto} createUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(tenantId: string, createUserDto: CreateUserDto, options?: any): AxiosPromise<UserDto> {
            return localVarFp.createUser(tenantId, createUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adds user to a group
         * @param {string} tenantId 
         * @param {string} userId 
         * @param {CreateGroupLinkDto} createGroupLinkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserGroupLink(tenantId: string, userId: string, createGroupLinkDto: CreateGroupLinkDto, options?: any): AxiosPromise<GroupLinkDto> {
            return localVarFp.createUserGroupLink(tenantId, userId, createGroupLinkDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Removes user from a group
         * @param {string} tenantId 
         * @param {string} userId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserGroupLink(tenantId: string, userId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteUserGroupLink(tenantId, userId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Finds a single user by search query. If more than one user was found 409 is returned.
         * @summary Find user
         * @param {string} tenantId 
         * @param {string} [name] User name to search for
         * @param {string} [userProfileId] Id of user profile to search for
         * @param {string} [email] User email to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUser(tenantId: string, name?: string, userProfileId?: string, email?: string, options?: any): AxiosPromise<UserDto> {
            return localVarFp.findUser(tenantId, name, userProfileId, email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user by id
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(tenantId: string, id: string, options?: any): AxiosPromise<UserDto> {
            return localVarFp.getUser(tenantId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets user group link by id
         * @param {string} tenantId 
         * @param {string} userId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupLink(tenantId: string, userId: string, id: string, options?: any): AxiosPromise<GroupLinkDto> {
            return localVarFp.getUserGroupLink(tenantId, userId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lists all user group links
         * @param {string} tenantId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupLinks(tenantId: string, userId: string, options?: any): AxiosPromise<Array<GroupLinkDto>> {
            return localVarFp.getUserGroupLinks(tenantId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List users
         * @param {string} tenantId 
         * @param {string} [googleUserId] 
         * @param {string} [externalId] 
         * @param {boolean} [includePii] If enabled, response will include email &amp; name. Сan be set only if googleUserId or externalId filter defined
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers(tenantId: string, googleUserId?: string, externalId?: string, includePii?: boolean, options?: any): AxiosPromise<Array<UserDto>> {
            return localVarFp.listUsers(tenantId, googleUserId, externalId, includePii, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @summary Create a user
     * @param {string} tenantId 
     * @param {CreateUserDto} createUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public createUser(tenantId: string, createUserDto: CreateUserDto, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).createUser(tenantId, createUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adds user to a group
     * @param {string} tenantId 
     * @param {string} userId 
     * @param {CreateGroupLinkDto} createGroupLinkDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public createUserGroupLink(tenantId: string, userId: string, createGroupLinkDto: CreateGroupLinkDto, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).createUserGroupLink(tenantId, userId, createGroupLinkDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Removes user from a group
     * @param {string} tenantId 
     * @param {string} userId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public deleteUserGroupLink(tenantId: string, userId: string, id: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).deleteUserGroupLink(tenantId, userId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Finds a single user by search query. If more than one user was found 409 is returned.
     * @summary Find user
     * @param {string} tenantId 
     * @param {string} [name] User name to search for
     * @param {string} [userProfileId] Id of user profile to search for
     * @param {string} [email] User email to search for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public findUser(tenantId: string, name?: string, userProfileId?: string, email?: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).findUser(tenantId, name, userProfileId, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user by id
     * @param {string} tenantId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUser(tenantId: string, id: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUser(tenantId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets user group link by id
     * @param {string} tenantId 
     * @param {string} userId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserGroupLink(tenantId: string, userId: string, id: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserGroupLink(tenantId, userId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lists all user group links
     * @param {string} tenantId 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserGroupLinks(tenantId: string, userId: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserGroupLinks(tenantId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List users
     * @param {string} tenantId 
     * @param {string} [googleUserId] 
     * @param {string} [externalId] 
     * @param {boolean} [includePii] If enabled, response will include email &amp; name. Сan be set only if googleUserId or externalId filter defined
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public listUsers(tenantId: string, googleUserId?: string, externalId?: string, includePii?: boolean, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).listUsers(tenantId, googleUserId, externalId, includePii, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersV2Api - axios parameter creator
 * @export
 */
export const UsersV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete user by id
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (tenantId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('deleteUser', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteUser', 'id', id)
            const localVarPath = `/api/v2/tenants/{tenantId}/users/{id}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset user password
         * @param {string} tenantId 
         * @param {string} id 
         * @param {ResetPasswordDto} resetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPassword: async (tenantId: string, id: string, resetPasswordDto: ResetPasswordDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('resetUserPassword', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resetUserPassword', 'id', id)
            // verify required parameter 'resetPasswordDto' is not null or undefined
            assertParamExists('resetUserPassword', 'resetPasswordDto', resetPasswordDto)
            const localVarPath = `/api/v2/tenants/{tenantId}/users/{id}/password`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user
         * @param {string} tenantId 
         * @param {string} id 
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (tenantId: string, id: string, updateUserDto: UpdateUserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateUser', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUser', 'id', id)
            // verify required parameter 'updateUserDto' is not null or undefined
            assertParamExists('updateUser', 'updateUserDto', updateUserDto)
            const localVarPath = `/api/v2/tenants/{tenantId}/users/{id}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersV2Api - functional programming interface
 * @export
 */
export const UsersV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete user by id
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(tenantId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(tenantId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reset user password
         * @param {string} tenantId 
         * @param {string} id 
         * @param {ResetPasswordDto} resetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetUserPassword(tenantId: string, id: string, resetPasswordDto: ResetPasswordDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetUserPassword(tenantId, id, resetPasswordDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update user
         * @param {string} tenantId 
         * @param {string} id 
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(tenantId: string, id: string, updateUserDto: UpdateUserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(tenantId, id, updateUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersV2Api - factory interface
 * @export
 */
export const UsersV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersV2ApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete user by id
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(tenantId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteUser(tenantId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset user password
         * @param {string} tenantId 
         * @param {string} id 
         * @param {ResetPasswordDto} resetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPassword(tenantId: string, id: string, resetPasswordDto: ResetPasswordDto, options?: any): AxiosPromise<void> {
            return localVarFp.resetUserPassword(tenantId, id, resetPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user
         * @param {string} tenantId 
         * @param {string} id 
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(tenantId: string, id: string, updateUserDto: UpdateUserDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateUser(tenantId, id, updateUserDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersV2Api - object-oriented interface
 * @export
 * @class UsersV2Api
 * @extends {BaseAPI}
 */
export class UsersV2Api extends BaseAPI {
    /**
     * 
     * @summary Delete user by id
     * @param {string} tenantId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersV2Api
     */
    public deleteUser(tenantId: string, id: string, options?: AxiosRequestConfig) {
        return UsersV2ApiFp(this.configuration).deleteUser(tenantId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset user password
     * @param {string} tenantId 
     * @param {string} id 
     * @param {ResetPasswordDto} resetPasswordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersV2Api
     */
    public resetUserPassword(tenantId: string, id: string, resetPasswordDto: ResetPasswordDto, options?: AxiosRequestConfig) {
        return UsersV2ApiFp(this.configuration).resetUserPassword(tenantId, id, resetPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user
     * @param {string} tenantId 
     * @param {string} id 
     * @param {UpdateUserDto} updateUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersV2Api
     */
    public updateUser(tenantId: string, id: string, updateUserDto: UpdateUserDto, options?: AxiosRequestConfig) {
        return UsersV2ApiFp(this.configuration).updateUser(tenantId, id, updateUserDto, options).then((request) => request(this.axios, this.basePath));
    }
}


